document.querySelectorAll('.shopify-section').forEach((el) => {
  const cls = [...el.classList].find((c) => c.startsWith('shopify-section--'));
  if (cls) el.dataset.sectionType = cls.replace('shopify-section--', '');
});

function debounce(fn, delay) {
  let timer = null;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

// 自定义：Chat Widget 滚动显示控制
function initChatWidgetScrollControl() {
  const widgetSelector = "#chat-widget-minimized";

  // [新增] 防止重复初始化：如果之前已经存在控制器，先清理
  if (window.chatWidgetScrollController) {
    try {
      window.chatWidgetScrollController.disconnect();
    } catch (e) {
      console.warn("Failed to disconnect previous chat widget controller", e);
    }
  }

  // 核心逻辑：根据滚动高度控制显示/隐藏
  const updateVisibility = () => {
    const widget = document.querySelector(widgetSelector);
    if (!widget) return;

    if (window.pageYOffset < 380) {
      // 使用 setProperty 以正确应用 !important
      widget.style.setProperty("display", "none", "important");
    } else {
      widget.style.display = "";
    }
  };

  // (1) 初始执行
  updateVisibility();

  // (2) 监听滚动
  window.addEventListener("scroll", updateVisibility);

  // (3) 监听DOM变化（处理动态加载）
  const observer = new MutationObserver((mutations) => {
    // 简单检查：如果组件存在，就尝试更新状态
    // 这样可以覆盖组件刚加载出来时的默认状态
    if (document.querySelector(widgetSelector)) {
      updateVisibility();
    }
  });

  // 监听 body 的子元素变化
  observer.observe(document.body, {
    childList: true,
    subtree: true // 因为不确定插件会插入到哪里，开启subtree
  });

  // [新增] 保存清理方法到全局对象，以便后续清理或防止重复绑定
  window.chatWidgetScrollController = {
    disconnect: () => {
      window.removeEventListener("scroll", updateVisibility);
      observer.disconnect();
      window.chatWidgetScrollController = null;
    }
  };
}

// 仅当手机端的时候调用这个方法
if (window.matchMedia("(max-width: 767px)").matches) {
  initChatWidgetScrollControl();
}

//自定义：to top悬浮按钮
class BackToTopButton extends HTMLElement {
  constructor() {
    super()
    this.handleScroll = this.handleScroll.bind(this)
    this.addEventListener("click", () => {
      window.scrollTo({ top: 0, behavior: "smooth" })
    })
  }

  connectedCallback() {
    window.addEventListener("scroll", this.handleScroll)
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.handleScroll)
  }

  handleScroll() {
    const viewportHeight = window.innerHeight
    const scrollPosition = window.scrollY || document.documentElement.scrollTop
    if (scrollPosition > viewportHeight + 280) {
      this.classList.add("show")
    } else {
      this.classList.remove("show")
    }
  }
}

if (!window.customElements.get("back-to-top-button")) {
  customElements.define("back-to-top-button", BackToTopButton)
}

//自定义：产品页附加产品功能
class AdditionalProducts extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.registerClickEvents()
    this.jointName() //默认先展示一次None
  }
  registerClickEvents() {
    this.querySelectorAll(".product-block-wrap").forEach((item) => {
      item.addEventListener("click", () => {
        if (item.classList.contains("active")) {
          item.classList.remove("active")
        } else {
          item.classList.add("active")
        }
        this.jointName()
      })
    })
  }
  jointName() {
    const allActiveWraps = this.querySelectorAll(".product-block-wrap.active")
    const optionValue = this.querySelector(".option-value")
    let jointText = Array.from(allActiveWraps).reduce((prev, item) => {
      const title = item.querySelector(".title").innerText + " / "
      return (prev += title)
    }, "")
    if (jointText.length > 0) {
      jointText = jointText.slice(0, -3)
    }
    optionValue.innerText = jointText || "None"
  }
}

if (!window.customElements.get("additional-products")) {
  customElements.define("additional-products", AdditionalProducts)
}

//自定义：判断pc还是h5的按钮功能
class CustomAElement extends HTMLElement {
  constructor() {
    super()
    this.addEventListener("click", this.handleClick)
  }

  handleClick(event) {
    event.preventDefault() // 阻止默认跳转行为

    const appleUrl = this.getAttribute("apple-url")
    const androidUrl = this.getAttribute("android-url")

    // 判断设备是否为手机
    const isMobile = window.matchMedia("(max-width: 767px)").matches

    // 判断是否为苹果设备或安卓设备
    const isAppleDevice = /iPhone|iPad|iPod|Macintosh/.test(navigator.userAgent)

    if (isMobile) {
      // 手机设备逻辑
      if (isAppleDevice && appleUrl) {
        window.location.href = appleUrl
      } else {
        window.location.href = androidUrl
      }
    } else {
      // 电脑设备逻辑
      const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0

      if (isMac && appleUrl) {
        window.location.href = appleUrl
      } else {
        window.location.href = androidUrl
      }
    }
  }
}

// 注册自定义元素
if (!window.customElements.get("custom-a")) {
  customElements.define("custom-a", CustomAElement)
}

/*
 自定义：order-support-link
 用于 order-support-third 分区中的入口卡片，根据登录状态决定跳转：
 - 已登录（localStorage.tor_auth 未过期）：直接跳转到 data-target
 - 未登录：跳转到 /pages/order-verification?return_url=<data-target>
 属性：
   data-target：目标页面的相对路径（必填）
*/
class OrderSupportLink extends HTMLElement {
  constructor() {
    super()
    this.addEventListener("click", this.handleNavigate.bind(this))
    this.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault()
        this.handleNavigate(e)
      }
    })
  }

  isLoggedIn() {
    try {
      const stored = localStorage.getItem("tor_auth")
      if (!stored) return false
      const auth = JSON.parse(stored)
      return !!(auth && auth.token && auth.expiry && Date.now() < auth.expiry)
    } catch (e) {
      return false
    }
  }

  handleNavigate() {
    const target = this.getAttribute("data-target")
    if (!target) return
    if (this.isLoggedIn()) {
      window.location.href = target
    } else {
      window.location.href = "/pages/order-verification?return_url=" + encodeURIComponent(target)
    }
  }
}

if (!window.customElements.get("order-support-link")) {
  customElements.define("order-support-link", OrderSupportLink)
}

/*
 自定义：order-support-slider
 用于 order-support-third 分区的图标入口多页滑动 + 页码指示器
 结构：
   <order-support-slider>
     <div class="support-third-viewport">
       <div class="support-third-track"> ...各页... </div>
     </div>
     <div class="support-third-pagination"> ...胶囊页码... </div>
   </order-support-slider>
 交互：
 - H5 触摸滑动、PC 鼠标拖拽，超过视口 15% 翻页，否则回弹
 - 点击胶囊页码可直接跳页
 - 拖拽后在捕获阶段拦截 click，避免误触发入口卡片跳转
*/
class OrderSupportSlider extends HTMLElement {
  constructor() {
    super()
    this.current = 0
    this.dragging = false
    this.moved = false
    this.startX = 0
    this.deltaX = 0
    this.goTo = this.goTo.bind(this)
    this.onStart = this.onStart.bind(this)
    this.onMove = this.onMove.bind(this)
    this.onEnd = this.onEnd.bind(this)
  }

  connectedCallback() {
    this.viewport = this.querySelector(".support-third-viewport")
    this.track = this.querySelector(".support-third-track")
    if (!this.viewport || !this.track) return

    this.dots = Array.prototype.slice.call(this.querySelectorAll(".support-third-dot"))
    this.pages = this.track.children.length

    this.dots.forEach((dot) => {
      dot.addEventListener("click", () => {
        this.goTo(parseInt(dot.getAttribute("data-index"), 10) || 0)
      })
    })

    // 单页时无需滑动交互
    if (this.pages <= 1) return

    this.viewport.classList.add("is-draggable")

    // 触摸滑动（H5）
    this.viewport.addEventListener("touchstart", (e) => this.onStart(e.touches[0].clientX), { passive: true })
    this.viewport.addEventListener("touchmove", (e) => this.onMove(e.touches[0].clientX), { passive: true })
    this.viewport.addEventListener("touchend", this.onEnd)
    this.viewport.addEventListener("touchcancel", this.onEnd)

    // 鼠标拖拽（PC）
    this.viewport.addEventListener("mousedown", (e) => {
      this.onStart(e.clientX)
      e.preventDefault()
    })
    window.addEventListener("mousemove", this.onMove)
    window.addEventListener("mouseup", this.onEnd)

    // 拖拽后抑制入口卡片的点击跳转（捕获阶段拦截）
    this.viewport.addEventListener(
      "click",
      (e) => {
        if (this.moved) {
          e.preventDefault()
          e.stopPropagation()
          this.moved = false
        }
      },
      true
    )
  }

  goTo(index) {
    this.current = Math.max(0, Math.min(index, this.pages - 1))
    this.track.style.transform = "translateX(" + -this.current * 100 + "%)"
    this.dots.forEach((dot, i) => dot.classList.toggle("is-active", i === this.current))
  }

  onStart(x) {
    this.dragging = true
    this.moved = false
    this.startX = x
    this.deltaX = 0
    this.track.style.transition = "none"
    this.viewport.classList.add("is-grabbing")
  }

  onMove(x) {
    if (!this.dragging) return
    // mousemove 传入的是事件对象，touch 传入的是坐标，这里统一处理
    if (typeof x === "object") x = x.clientX
    this.deltaX = x - this.startX
    if (Math.abs(this.deltaX) > 6) this.moved = true
    const percent = (this.deltaX / this.viewport.offsetWidth) * 100
    this.track.style.transform = "translateX(" + (-this.current * 100 + percent) + "%)"
  }

  onEnd() {
    if (!this.dragging) return
    this.dragging = false
    this.track.style.transition = ""
    this.viewport.classList.remove("is-grabbing")
    const threshold = this.viewport.offsetWidth * 0.15
    if (this.deltaX < -threshold) this.goTo(this.current + 1)
    else if (this.deltaX > threshold) this.goTo(this.current - 1)
    else this.goTo(this.current)
  }
}

if (!window.customElements.get("order-support-slider")) {
  customElements.define("order-support-slider", OrderSupportSlider)
}

//自定义：comparison table，点击按钮
/* 
参数：
white-modal-id：white-modal的id，等于white-modal.liquid的modal_type参数
pc-modal-id：pc-modal的id，等于pc-modal.liquid的modal_type参数
white-modal-height-factor：white-modal的高度因子，通常是0 - 1之间的小数

inner-id: 如果是多个内容共用弹窗的话，那具体展示哪个内容，需要通过此id指定
*/
class dialogButton extends HTMLElement {
  constructor() {
    super()
    // 绑定this
    this.initPhoneWhiteModal = this.initPhoneWhiteModal.bind(this)
    this.commonModal = this.hasAttribute("common-modal")
    if(this.commonModal) {
      this.h5CommonModalShowDom = document.querySelector(`.white-modal #${this.getAttribute("inner-id")}`)
      this.pcCommonModalShowDom = document.querySelector(`pc-modal #${this.getAttribute("inner-id")}`)
    } else {
      this.h5CommonModalShowDom = document.querySelector("#h5-comparison-modal")
    }

    this.whiteModalId = this.getAttribute("white-modal-id")
    this.pcModalId = this.getAttribute("pc-modal-id")
    this.whiteModalHeightFactor = parseFloat(this.getAttribute("white-modal-height-factor")) || 0.15

    // 缓存DOM元素，避免重复查询
    this.modal = document.querySelector(`#${this.whiteModalId}`)
    this.modalContent = this.modal.querySelector(".white-modal-content")
    this.modalInner = this.modal.querySelector(".white-modal-inner")

    // 业务逻辑
    this.addEventListener("click", this.handleClick)
    this.initPhoneWhiteModal()
  }
  
  initPhoneWhiteModal() {
    const _this = this
    this.modal.addEventListener("click", function (event) {
      // 检查点击是否在 .white-modal-content 区域之外
      if (!event.target.closest(".white-modal-content") || event.target.closest(".white-modal-close")) {
        _this.closePhoneWhiteModal()
      }
    })
    this.modalContent.addEventListener("scroll", function (event) {
      event.stopPropagation()
      if (event.cancelable) {
        event.preventDefault()
      }
    })
  }

  handleClick() {
    // 判断设备是否为手机
    const isMobile = window.matchMedia("(max-width: 767px)").matches
    if (isMobile) {
      this.openPhoneWhiteModal()
      document.body.style.overflow = 'hidden';
    } else {
      this.openPcModal()
    }
  }
  openPcModal() {
    this.listenPcModalClose()
    const pcModal = document.querySelector(`#${this.pcModalId}`)
    if(this.commonModal) {
      this.pcCommonModalShowDom.classList.remove("hidden")
    }
    if (pcModal) {
      pcModal.style.display = "block"
    }
  }
  listenPcModalClose() {
    document.addEventListener("dialog:close", (info)=>{
      console.log("info.detail.dialogType:",info.detail.dialogType)
      if(info.detail.dialogType == this.getAttribute("pc-modal-type")){
        this.pcCommonModalShowDom.classList.add("hidden")
      }
    })
  }
  openPhoneWhiteModal() {
    if(this.commonModal) {
      this.h5CommonModalShowDom.classList.remove("hidden")
    }
    this.modal.style.display = "block"

    setTimeout(() => {
      // 计算顶部位置
      let viewportHeight = window.innerHeight
      let modalTopAttrValue = viewportHeight * this.whiteModalHeightFactor
      // 应用计算后的顶部位置
      this.modalContent.style.top = modalTopAttrValue + "px"
    }, 10) // 小的超时来触发过渡
  }

  closePhoneWhiteModal() {
    document.body.style.overflow = "unset";
    this.modalContent.style.top = "100%"
    setTimeout(() => {
      this.h5CommonModalShowDom.classList.add("hidden")
      this.modal.style.display = "none"
    }, 300) // 与CSS过渡时间匹配
  }
}

// 注册自定义元素
if (!window.customElements.get("dialog-button")) {
  customElements.define("dialog-button", dialogButton)
}

class PcModal extends HTMLElement {
  constructor() {
    super()
    this._modal = this.querySelector(".modal-content")
    this.modalType = this.getAttribute("modal-type")
    this._closeButton = this.querySelector(".close")
    // 打开和关闭模态框的功能
    this.open = this.open.bind(this)
    this.close = this.close.bind(this)

    // 监听关闭按钮的点击事件
    if (this._closeButton) {
      this._closeButton.addEventListener("click", this.close)
    }

    // 监听点击模态框外部时关闭模态框
    this.addEventListener("click", (event) => {
      if (event.target === this) {
        this.close()
      }
    })
  }

  // 打开模态框
  open() {
    this.style.display = "block"
    this._modal.classList.remove("modal-hide")
  }

  // 关闭模态框
  close() {
    if(this.modalType){
      const event = new CustomEvent("dialog:close",{
        detail: {
          dialogType: this.modalType
        },
      })
      document.dispatchEvent(event) // 触发事件
    }
    this.style.display = "none"
  }
}
if (!window.customElements.get("pc-modal")) {
  // 定义自定义元素
  customElements.define("pc-modal", PcModal)
}

/* media-compose-marquee中用到了video，该组件开启自动播放 */
class videoBesideMaquee extends HTMLElement {
  constructor() {
    super()
    setTimeout(() => {
      this._playVideo()
    }, 0);
  }
  _playVideo(){
    this.videoMedia = this.querySelector("video-media")
    this.videoMedia.play({ restart: true });
  }
}
if (!window.customElements.get("video-beside-maquee")) {
  // 定义自定义元素
  customElements.define("video-beside-maquee", videoBesideMaquee)
}

// js/development/sliderTabs.js
import { animate as animate50 } from "vendor";
var sliderTabs = class extends HTMLElement {
  static get observedAttributes() {
    return ["selected-index"];
  }
  constructor() {
    super();
    this.slider = this.querySelector(".slider");
    if (!this.shadowRoot) {
      this.attachShadow({ mode: "open" }).appendChild(this.querySelector("template").content.cloneNode(true));
    }
    if (Shopify.designMode) {
      this.addEventListener("shopify:block:select", (event) => this.selectedIndex = this.buttons.indexOf(event.target));
    }
    this.addEventListener("keydown", this._handleKeyboard);
    document.addEventListener("swiperOfSliderTabs:change", debounce(this._changeTabByIndex.bind(this), 300));
  }
  connectedCallback() {
    this._abortController = new AbortController();
    this.buttons = Array.from(this.shadowRoot.querySelector('slot[name="title"]').assignedNodes(), (item) => item.matches("button") && item || item.querySelector("button"));
    this.panels = Array.from(this.shadowRoot.querySelector('slot[name="content"]').assignedNodes());
    this.buttons.forEach((button, index) => button.addEventListener("click", () => {
      this.selectedIndex = index
      const event = new CustomEvent("sliderTabs:change", {
        detail: {
          index: index,
        },
      })
      document.dispatchEvent(event) // 触发事件
    }, { signal: this._abortController.signal }));
    this.selectedIndex = this.selectedIndex;
    this._setupAccessibility();
  }
  disconnectedCallback() {
    this._abortController.abort();
  }
  get animationDuration() {
    return this.hasAttribute("animation-duration") ? parseFloat(this.getAttribute("animation-duration")) : 0.15;
  }
  get selectedIndex() {
    return parseInt(this.getAttribute("selected-index")) || 0;
  }
  set selectedIndex(index) {
    this.setAttribute("selected-index", Math.min(Math.max(index, 0), this.buttons.length - 1).toString());
    this.style.setProperty("--selected-index", this.selectedIndex.toString());
    this.style.setProperty("--item-count", this.buttons.length.toString());
  }
  attributeChangedCallback(name, oldValue, newValue) {
    this.buttons.forEach((button, index) => button.setAttribute("aria-selected", index === parseInt(newValue) ? "true" : "false"));
    if (name === "selected-index" && oldValue !== null && oldValue !== newValue) {
      this._transitionTab(this.slider, parseInt(newValue));
      this._transitionContent(this.panels[parseInt(oldValue)], this.panels[parseInt(newValue)]);
    }
  }
  _setupAccessibility() {
    const componentID = crypto.randomUUID ? crypto.randomUUID() : Math.floor(Math.random() * 1e4);
    this.buttons.forEach((button, index) => {
      button.setAttribute("role", "tab");
      button.setAttribute("aria-controls", `tab-panel-${componentID}-${index}`);
      button.id = `tab-${componentID}-${index}`;
    });
    this.panels.forEach((panel, index) => {
      panel.setAttribute("role", "tabpanel");
      panel.setAttribute("aria-labelledby", `tab-${componentID}-${index}`);
      panel.id = `tab-panel-${componentID}-${index}`;
      panel.hidden = index !== this.selectedIndex;
    });
  }
  _changeTabByIndex(event) {
    const index = event.detail.index;
    if (index >= 0 && index < this.buttons.length) {
      this.selectedIndex = index;
    }
  }
  /**
   * As per https://www.w3.org/WAI/ARIA/apg/example-index/tabs/tabs-automatic.html, when a tab is currently focused,
   * left and right arrow should switch the tab
   */
  _handleKeyboard(event) {
    const index = this.buttons.indexOf(document.activeElement);
    if (index === -1 || !["ArrowLeft", "ArrowRight"].includes(event.key)) {
      return;
    }
    if (event.key === "ArrowLeft") {
      this.selectedIndex = (this.selectedIndex - 1 + this.buttons.length) % this.buttons.length;
    } else {
      this.selectedIndex = (this.selectedIndex + 1 + this.buttons.length) % this.buttons.length;
    }
    this.buttons[this.selectedIndex].focus();
  }
  /**
   * Perform a custom transition (can be overridden in subclasses). To "from" and "to" are hash representing the panel
   */
  async _transitionTab(slider, toIndex) {
    await animate50(slider, { x: `${toIndex * 100}%` }, { duration: 0.3, easing: "ease-in-out" }).finished;
  }
  async _transitionContent(fromPanel, toPanel) {
    await animate50(fromPanel, { opacity: [1, 0] }, { duration: this.animationDuration }).finished;
    fromPanel.hidden = true;
    toPanel.hidden = false;
    await animate50(toPanel, { opacity: [0, 1] }, { duration: this.animationDuration }).finished;
  }
};
if (!window.customElements.get("slider-tabs")) {
  window.customElements.define("slider-tabs", sliderTabs);
}

// js/development/sliderTabsPcCarousel.js
// 将轮播图抽到单独的组件中【其实就应该这样抽，但是代码当中有一些是<script></script>去弄的】
var sliderTabsPcCarousel = class extends HTMLElement {
  constructor() {
    super();
    this.actualSlideNum = parseInt(this.getAttribute("actual-slide-num"));
    this.stretchValue = parseInt(this.getAttribute("stretch-value")) || -120
    document.addEventListener("sliderTabs:change", this._changeSlideByIndex.bind(this));
    if(!window.matchMedia("(max-width: 767px)").matches) {
      this.targetSwiper = this._initPcSwiper();
      this._listenSwiperChange(this.targetSwiper);
    }
  }
  _initPcSwiper() {
    const targetDom = this.querySelector(".swiper-container");
    if(!targetDom) return null;
    return new Swiper(targetDom, {
      effect: 'coverflow',
      centeredSlides: true,
      slidesPerView: 1.5, // ✅ 显示1.5个slide，两边各漏一点
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      coverflowEffect: {
        rotate: 0,
        stretch: this.stretchValue, // ✅ 负值让两侧图片稍微收缩
        depth: 800,
        modifier: 1,
        slideShadows: true, // ✅ 关闭阴影，按需调整
      },
    });
  }
  _listenSwiperChange(targetSwiper) {
    const tempActualSlideNum = this.actualSlideNum
    targetSwiper.on('realIndexChange', function () {
      const event = new CustomEvent("swiperOfSliderTabs:change", {
        detail: { //因为swiper在3个slide的时候，存在bug时，所以liquid中处理了代码，同时这里也要处理。
          index: tempActualSlideNum > 3 ? targetSwiper.realIndex : (targetSwiper.realIndex % tempActualSlideNum),
        },
      });
      document.dispatchEvent(event); // 触发事件
    });
  }
  _changeSlideByIndex(event) {
    const index = event.detail.index;
    if(this.targetSwiper) {
      this.targetSwiper.slideToLoop(index);
    }
  }
}
if (!window.customElements.get("slider-tabs-pc-carousel")) {
  window.customElements.define("slider-tabs-pc-carousel", sliderTabsPcCarousel);
}

// js/development/pcH5Carousel.js
// h5-show-num：一屏展示多少张图片
// h5-picture-gap：图片间距
// carousel-speed：轮播速度
var pcH5Carousel = class extends HTMLElement {
  constructor() {
    super();
    if(window.matchMedia("(max-width: 767px)").matches) {
      this._initH5Swiper();
    } else {
      this._initPcSwiper();
    }
  }
  _initH5Swiper() {
    const h5CarouselDom = this.querySelector('.h5-swiper-container');
    if (!h5CarouselDom) return;

    // 获取属性值并设置默认值
    const slidesPerView = parseFloat(this.getAttribute('h5-show-num')) || 1;
    const spaceBetween = parseInt(this.getAttribute('h5-picture-gap')) || 0;
    const carouselSpeed = parseInt(this.getAttribute('carousel-speed')) || 0;

    // 基础配置
    const config = {
      slidesPerView: slidesPerView,
      spaceBetween: spaceBetween,
      loop: true,
      grabCursor: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    };

    // 处理自动轮播
    if (carouselSpeed !== 0) {
      config.autoplay = {
        delay: carouselSpeed * 1000,
        disableOnInteraction: false,
      };
    }

    // 初始化 Swiper
    new Swiper(h5CarouselDom, config);
  }
  _initPcSwiper() {
    const pcCarouselDom = this.querySelector('.swiper-container');
    if (!pcCarouselDom) return;

    const carouselSpeed = parseInt(this.getAttribute('carousel-speed')) || 0;

    const config = {
      effect: "coverflow",
      grabCursor: true,
      centeredSlides: true,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 300,
        modifier: 1,
        slideShadows: true,
      },
      breakpoints: {
        767: {
          slidesPerView: 3,
          loop: false,
          coverflowEffect: {
            rotate: 0,
            depth: 100,
            slideShadows: false,
          },
        },
        768: {
          slidesPerView: "auto",
          loop: true,
          coverflowEffect: {
            rotate: 0,
            depth: 300,
            slideShadows: true,
          },
        },
      },
    };

    if (carouselSpeed !== 0) {
      config.autoplay = {
        delay: carouselSpeed * 1000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    new Swiper(pcCarouselDom, config);
  }
}

if (!window.customElements.get("pc-h5-carousel")) {
  window.customElements.define("pc-h5-carousel", pcH5Carousel);
}

class AnimationText extends HTMLElement {
  constructor() {
    super();
    this.from = 0; // 默认起始值
    this.currentValue = 0;
    this.hasAnimated = false; // 跟踪动画是否已经播放过
    this.observer = null;
    this.originalText = ''; // 存储原始文本以分析格式
    this.decimalPlaces = 0; // 存储小数位数
  }

  connectedCallback() {
    // 保存原始文本
    this.originalText = this.textContent.trim();
    
    // 获取目标值
    this.to = parseFloat(this.originalText);

    if (isNaN(this.to)) {
      return;
    }

    this.duration = parseFloat(this.getAttribute('duration')) || 1.0;
    
    // 设置起始值（从0开始或者目标值的一小部分）
    this.from = this.to > 100 ? this.to * 0.5 : 0;
    
    // 分析原始数字的小数位数
    this.analyzeDecimalPlaces();
    
    // 初始显示起始值
    this.updateNumber(this.from);
    
    // 使用 IntersectionObserver 监视元素是否进入视口
    this.setupIntersectionObserver();
  }

  // 分析原始数字的小数位数
  analyzeDecimalPlaces() {
    const parts = this.originalText.split('.');
    if (parts.length > 1) {
      this.decimalPlaces = parts[1].length;
    } else {
      this.decimalPlaces = 0;
    }
  }

  setupIntersectionObserver() {
    this.observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      
      // 当元素进入视口且动画尚未播放时开始动画
      if (entry.isIntersecting && !this.hasAnimated) {
        setTimeout(() => {
          this.animateNumberChange(this.from, this.to);
          this.hasAnimated = true;
        }, 600);
      }
    }, {
      threshold: 0.1 // 当元素有10%进入视口时触发
    });
    
    this.observer.observe(this);
  }

  // 缓动函数 - 指数减速
  easeOutExpo(x) {
    return x === 1 ? 1 : 1 - Math.pow(2, -10 * x);
  }

  // 更新显示的数字，保持与原始输入相同的小数位数
  updateNumber(value) {
    this.currentValue = value;
    // 使用分析出的小数位数格式化数字
    this.textContent = value.toFixed(this.decimalPlaces);
  }

  async animateNumberChange(from, to) {
    if (!window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
      // 如果用户偏好减少动画，则直接显示最终结果而不进行动画
      this.updateNumber(to);
      return;
    }
    
    const duration = this.duration; // 动画持续时间，单位秒
    const startTime = performance.now();
    
    const animate = (currentTime) => {
      const elapsed = (currentTime - startTime) / 1000; // 转换为秒
      const progress = Math.min(elapsed / duration, 1);
      const easedProgress = this.easeOutExpo(progress);
      const currentValue = from + (to - from) * easedProgress;
      
      this.updateNumber(currentValue);
      
      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };
    
    requestAnimationFrame(animate);
  }

  disconnectedCallback() {
    // 清理观察器以防止内存泄漏
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}

// 注册自定义元素
if (!window.customElements.get("animation-text")) {
  customElements.define("animation-text", AnimationText);
}

// 一级菜单激活时显示滑动红条（is="nav-active-bar-container"）
class NavActiveBarContainer extends HTMLElement {
  connectedCallback() {
    if (this._inited) return;
    this._inited = true;
    this.bar = this.querySelector(':scope > .nav-active-bar');
    if (!this.bar) return;
    this.items = Array.from(this.querySelectorAll(':scope > ul > li.first-level-li'));
    this.observers = [];
    this.items.forEach((li) => {
      const details = li.querySelector(':scope > details');
      if (details) {
        details.addEventListener('toggle', () => this.update());
      }
    });
    this._onResize = () => this.update();
    window.addEventListener('resize', this._onResize);
    requestAnimationFrame(() => this.update());
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this._onResize);
  }

  update() {
    if (!this.bar) return;
    const activeLi = this.items.find((li) => {
      const d = li.querySelector(':scope > details');
      return d && d.open;
    });
    if (!activeLi) {
      this.bar.classList.remove('is-active');
      return;
    }
    const target = activeLi.querySelector(':scope > details > summary') || activeLi;
    const containerRect = this.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();
    const left = targetRect.left - containerRect.left;
    const width = targetRect.width;
    this.bar.style.transform = `translateX(${left}px)`;
    this.bar.style.width = `${width}px`;
    this.bar.classList.add('is-active');
  }
}
if (!window.customElements.get('nav-active-bar-container')) {
  customElements.define('nav-active-bar-container', NavActiveBarContainer, { extends: 'nav' });
}

// 左侧菜单切换右侧内容的自定义元素
class leftSwitchMegaMenu extends HTMLElement {
  constructor() {
    super();
    this.triggerType = this.getAttribute('trigger-type') || 'click';
    this.init();
  }

  init() {
    // 获取所有左侧菜单项
    this.menuItems = this.querySelectorAll('.left-menu-item');
    // 获取所有右侧面板
    this.panels = this.querySelectorAll('.second-third-level-panel');
    
    // 根据触发类型添加不同的事件监听
    if (this.triggerType === 'hover') {
      this.menuItems.forEach(item => {
        item.addEventListener('mouseenter', this.handleMenuItemClick.bind(this, item));
      });
    } else {
      this.menuItems.forEach(item => {
        item.addEventListener('click', this.handleMenuItemClick.bind(this, item));
      });
    }
  }

  handleMenuItemClick(clickedItem) {
    // 获取点击的菜单项索引
    const index = clickedItem.dataset.index;
    
    // 移除所有菜单项的active类
    this.menuItems.forEach(item => {
      item.classList.remove('active');
    });
    
    // 为点击的菜单项添加active类
    clickedItem.classList.add('active');
    
    // 隐藏所有面板
    this.panels.forEach(panel => {
      panel.classList.remove('active');
    });
    
    // 显示对应的面板
    const targetPanel = this.querySelector(`.second-third-level-panel[data-panel-index="${index}"]`);
    if (targetPanel) {
      targetPanel.classList.add('active');
      
      // 添加动画效果
      this.animatePanelChange(targetPanel);
    }
  }
  
  animatePanelChange(panel) {
    // 为面板添加简单的淡入效果
    panel.style.opacity = '0';
    panel.style.transform = 'translateY(10px)';
    
    // 使用requestAnimationFrame确保DOM更新后再应用动画
    requestAnimationFrame(() => {
      panel.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
      panel.style.opacity = '1';
      panel.style.transform = 'translateY(0)';
      
      // 清除过渡效果，以便下次切换
      setTimeout(() => {
        panel.style.transition = '';
      }, 300);
    });
  }
}

if (!window.customElements.get('left-switch-mega-menu')) {
  customElements.define('left-switch-mega-menu', leftSwitchMegaMenu);
}

// 左侧菜单切换右侧内容的自定义元素
class localizationSelector extends HTMLElement {

  /**
   * Helper function to get a cookie by name.
   * @param {string} name The name of the cookie.
   * @returns {string|null} The cookie value or null if not found.
   */
  _getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }
  
  /**
   * Helper function to set a cookie.
   * @param {string} name The name of the cookie.
   * @param {string} value The value of the cookie.
   * @param {number} [days=7] The number of days until the cookie expires.
   */
  _setCookie(name, value, days = 7) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    // Set path=/ to make the cookie available site-wide
    document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax";
  }

  /**
   * Checks if the affiliate tracking ID exists in the URL query string.
   * If it does, store it in our own cookie for immediate access.
   */
  handleUrlQueryToCookie() {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const imRefValue = urlParams.get('im_ref');

      if (imRefValue) {
        console.log(`Found 'im_ref' in URL, setting 'selfhandle_irclickid' cookie.`);
        this._setCookie('selfhandle_irclickid', imRefValue);
      }
    } catch (e) {
      console.error("Error processing URL parameters:", e);
    }
  }

  /**
   * Called when the element is added to the DOM.
   */
  connectedCallback() {
    // 1. 立即检查URL参数并设置我们自己的cookie
    this.handleUrlQueryToCookie();

    // 2. 开始轮询，以寻找我们自己的cookie或第三方设置的cookie
    this._pollForAffiliateId();
  }

  /**
   * Polls for either 'selfhandle_irclickid' or 'irclickid' cookie.
   */
  _pollForAffiliateId() {
    const pollInterval = 100; // Check every 100ms
    const maxDuration = 6000; // Stop after 6 seconds
    const startTime = Date.now();

    const intervalId = setInterval(() => {
      // 检查我们自己设置的cookie或第三方设置的cookie
      const selfHandledId = this._getCookie('selfhandle_irclickid');
      const thirdPartyId = this._getCookie('irclickid');
      
      const finalId = selfHandledId || thirdPartyId;

      // --- Success Condition ---
      // 如果任意一个cookie存在，则停止轮询并重写链接
      if (finalId) {
        clearInterval(intervalId);
        console.log(`Affiliate ID found: ${finalId}. Ceasing poll.`);
        this._rewriteLinks(finalId);
        return;
      }

      // --- Timeout Condition ---
      // 如果6秒已过，则停止轮询
      if (Date.now() - startTime > maxDuration) {
        clearInterval(intervalId);
        console.warn('Polling for affiliate ID timed out after 6 seconds.');
      }
    }, pollInterval);
  }

  /**
   * Rewrites the links with the affiliate tracking parameter.
   * @param {string} affiliateId The affiliate ID found.
   */
  _rewriteLinks(affiliateId) {
    const urlsToRewrite = [
      'https://ca.deerruntreadmill.com',
      'https://eu.deerruntreadmill.com',
    ];

    this.querySelectorAll('.popover-listbox__option').forEach(link => {
      try {
        if (link.href && (link.href.startsWith('http:') || link.href.startsWith('https://'))) {
          const url = new URL(link.href);
          if (urlsToRewrite.includes(url.origin)) {
            url.searchParams.set('im_ref', affiliateId);
            link.href = url.toString();
          }
        }
      } catch (e) {
        console.error(`Invalid URL for localization selector: ${link.href}`, e);
      }
    });
  }
}

// 确保自定义元素被定义
if (!customElements.get('localization-selector')) {
  customElements.define('localization-selector', localizationSelector);
}

// 新的附加产品组件
class NewAdditionalProducts extends HTMLElement {
  constructor() {
    super();
    this.selectedProducts = new Set(); // 存储选中的产品ID
    this.isExpanded = false; // 展开状态
    this.collapsedMaxHeight = null; // 收起时的最大高度
  }

  connectedCallback() {
    this.init();
    
    // 延迟检查溢出状态，确保DOM完全渲染
    setTimeout(() => {
      this.checkOverflowAndGradient();
      this.checkExpandCollapseNeeded();
    }, 100);
    
    // 监听窗口大小变化，重新检查溢出状态
    this.resizeObserver = new ResizeObserver(() => {
      this.checkOverflowAndGradient();
      this.checkExpandCollapseNeeded();
    });
    this.resizeObserver.observe(this);
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  init() {
    // 为每个产品项绑定点击事件
    this.querySelectorAll('.new-additional-product-item').forEach(item => {
      this.setupProductItem(item);
    });
    
    // 为展开/收起按钮绑定点击事件
    this.setupExpandCollapseButton();
    // 为Shuffle按钮绑定点击事件
    this.setupShuffleButton();
  }
  
  setupExpandCollapseButton() {
    const expandBtn = this.querySelector('.expand-collapse-btn');
    if (!expandBtn) return;
    
    expandBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      this.toggleExpandCollapse();
    });
  }

  setupShuffleButton() {
    const shuffleBtn = this.querySelector('.shuffle-btn');
    if (!shuffleBtn) return;

    shuffleBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      this.handleShuffle(shuffleBtn);
    });
  }

  async handleShuffle(btn) {
    if (this.isShuffling) return;
    this.isShuffling = true;
    btn.classList.add('rotating');

    try {
      this.shuffleProducts();
    } catch (e) {
      console.error('Shuffle error:', e);
    }

    setTimeout(() => {
      btn.classList.remove('rotating');
      this.isShuffling = false;
    }, 500);
  }

  shuffleProducts() {
    const poolScript = this.querySelector('.nap-data-pool');
    if (!poolScript) return;
    
    let poolData;
    try {
      poolData = JSON.parse(poolScript.textContent);
    } catch(e) {
      return;
    }

    const allProducts = poolData.products || [];
    const iconMap = poolData.icon_map || {};
    
    // 获取当前页面上存在的产品ID（包括选中的和未选中的）
    const currentItems = Array.from(this.querySelectorAll('.new-additional-product-item'));
    const currentIds = new Set();
    currentItems.forEach(item => {
      const data = this.getProductData(item);
      if (data && data.id) currentIds.add(data.id);
    });
    
    // 筛选出未选中的DOM元素（即需要被替换的位置）
    const candidates = currentItems.filter(item => !item.classList.contains('selected'));
    if (candidates.length === 0) return;

    // 从池子中筛选出不在当前页面上的产品
    const available = allProducts.filter(p => !currentIds.has(p.id));
    if (available.length === 0) return;

    // 加权随机打乱 (带有图标的产品权重更高)
    const shuffled = available.map(p => {
      // 检查是否有图标
      const hasIcon = !!iconMap[String(p.id)];
      // 权重: 有图标 1.3 (提升30%), 无图标 1.0
      const weight = hasIcon ? 30 : 1.0;
      // 使用加权随机分数 (Weighted Random Score)
      const score = Math.pow(Math.random(), 1 / weight);
      return { product: p, score: score };
    })
    .sort((a, b) => b.score - a.score)
    .map(item => item.product);

    // 替换逻辑
    candidates.forEach((item, index) => {
      if (index < shuffled.length) {
        this.replaceProductItem(item, shuffled[index], iconMap);
      }
    });
    
    // GTM: 收集 shuffle 后所有可见衍生品的信息并推送到 dataLayer
    this.pushShuffledDataToGTM();
  }

  pushShuffledDataToGTM() {
    const allItems = this.querySelectorAll('.new-additional-product-item');
    const productIds = [];
    const productNames = [];

    allItems.forEach(item => {
      productIds.push(item.dataset.productId)
      const productName = item.querySelector(".product-title")?.innerText;
      productNames.push(productName);
    });

    window.dataLayer = window.dataLayer || [];
    const layerInfo = {
      'event': 'additional_product_shuffle_completed',
      'dlv_additional_product_ids': productIds,
      'dlv_additional_product_names': productNames,
    }
    console.log("layerInfo：",layerInfo);
    window.dataLayer.push(layerInfo);
  }

  replaceProductItem(item, product, iconMap) {
    // 1. 更新 data-product-handle
    item.setAttribute('data-product-handle', product.handle);

    // 2. 更新 Corner Icon
    let cornerIcon = item.querySelector('.product-corner-icon');
    const iconUrl = iconMap[String(product.id)]; // Key is string in JSON
    
    if (iconUrl) {
      if (!cornerIcon) {
        cornerIcon = document.createElement('div');
        cornerIcon.className = 'product-corner-icon';
        const img = document.createElement('img');
        img.width = 60;
        img.height = 60; 
        img.loading = 'lazy';
        cornerIcon.appendChild(img);
        item.appendChild(cornerIcon);
      }
      const img = cornerIcon.querySelector('img');
      if (img) img.src = iconUrl;
      cornerIcon.style.display = 'block';
    } else {
      if (cornerIcon) cornerIcon.style.display = 'none';
    }

    // 3. 更新主图
    const mainImg = item.querySelector('.product-image img');
    if (mainImg) {
      mainImg.src = product.featured_image;
      mainImg.alt = product.title;
    }

    // 4. 更新标题
    const titleEl = item.querySelector('.product-title');
    if (titleEl) {
      titleEl.textContent = product.title;
    }

    // 5. 更新变体选择器
    const variantContainer = item.querySelector('.product-variant-selector');
    if (product.variants && product.variants.length > 1) {
      if (!variantContainer) {
        // 如果之前没有容器，创建一个，插入到 title 后面
        const newContainer = document.createElement('div');
        newContainer.className = 'product-variant-selector';
        const infoDiv = item.querySelector('.new-additional-product-info');
        if (infoDiv) {
            if (titleEl) {
                 infoDiv.insertBefore(newContainer, titleEl.nextSibling);
            } else {
                 infoDiv.appendChild(newContainer);
            }
        }
      }
      
      // 重新获取容器
      const container = item.querySelector('.product-variant-selector');
      if (container) {
        container.innerHTML = ''; // 清空
        container.classList.remove('hidden');
        container.style.display = ''; // 清除可能存在的内联样式
        const select = document.createElement('select');
        select.className = 'variant-select';
        select.name = `variant-${product.id}`;
        
        product.variants.forEach(v => {
          const opt = document.createElement('option');
          opt.value = v.id;
          opt.dataset.price = v.price;
          opt.dataset.comparePrice = v.compare_at_price || '';
          opt.dataset.image = v.image || '';
          opt.textContent = v.title;
          if (v.id === product.variants[0].id) opt.selected = true;
          select.appendChild(opt);
        });
        
        container.appendChild(select);
        
        // 重新绑定事件
        select.addEventListener('change', (e) => {
          e.stopPropagation();
          this.handleVariantChange(item, e.target);
        });
      }
    } else {
      if (variantContainer) {
        variantContainer.classList.add('hidden');
        variantContainer.style.display = ''; // 清除可能存在的内联样式
      }
    }

    // 6. 更新价格
    const currentPriceEl = item.querySelector('.current-price');
    if (currentPriceEl) {
      currentPriceEl.textContent = '$' + this.formatPrice(product.price);
    }
    
    const comparePriceEl = item.querySelector('.compare-price');
    if (comparePriceEl) {
      if (product.compare_at_price && product.compare_at_price > product.price) {
        comparePriceEl.textContent = '$' + this.formatPrice(product.compare_at_price);
        comparePriceEl.style.display = 'inline';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }

    // 7. 更新隐藏的数据 Script
    const scriptData = item.querySelector('.product-data');
    if (scriptData) {
      scriptData.textContent = JSON.stringify(product);
    }

    // 8. 确保状态为未选中
    item.classList.remove('selected');
    this.updateSelectButton(item, false);
    
    // 如果有变体，初始化显示
    if (product.variants && product.variants.length > 0) {
        const firstVariant = product.variants[0];
        const variantData = {
          id: firstVariant.id,
          price: firstVariant.price,
          comparePrice: firstVariant.compare_at_price,
          image: firstVariant.image
        };
        this.updateProductDisplay(item, variantData, product);
    }
  }
  
  checkExpandCollapseNeeded() {
    const items = this.querySelectorAll('.new-additional-product-item');
    const wrapper = this.querySelector('.new-additional-products-wrapper');
    if (!wrapper) return;
    
    const expandBtn = this.querySelector('.expand-collapse-line');
    if (!expandBtn) return;
    
    // 如果产品数量 >= 4，则显示展开/收起按钮
    if (items.length >= 4) {
      this.style.paddingBottom = '30px';
      // 计算前3个产品的总高度
      this.calculateCollapsedHeight(items);
      
      // 显示按钮
      expandBtn.style.display = 'flex';
      
      // 初始状态为收起
      if (!this.isExpanded) {
        this.collapse();
      }
    } else {
      // 产品少于4个，隐藏按钮，移除高度限制
      expandBtn.style.display = 'none';
      this.style.maxHeight = 'none';
      wrapper.classList.remove('expanded');
    }
  }
  
  calculateCollapsedHeight(items) {
    // 计算前3个产品的总高度 + gap
    if (items.length < 3) return;
    
    let totalHeight = 0;
    const gap = 12; // gap between items
    
    for (let i = 0; i < 3; i++) {
      totalHeight += items[i].offsetHeight;
      if (i < 2) totalHeight += gap; // 添加gap，除了最后一个
    }
    
    // 添加padding-top
    totalHeight += 8;
    
    this.collapsedMaxHeight = totalHeight;
  }
  
  toggleExpandCollapse() {
    const wrapper = this.querySelector('.new-additional-products-wrapper');
    if (!wrapper) return;
    
    if (this.isExpanded) {
      this.collapse();
    } else {
      this.expand();
    }
  }
  
  collapse() {
    const wrapper = this.querySelector('.new-additional-products-wrapper');
    if (!wrapper) return;
    
    this.isExpanded = false;
    wrapper.classList.remove('expanded');
    
    // 设置最大高度为前3个产品的高度
    if (this.collapsedMaxHeight) {
      this.style.maxHeight = this.collapsedMaxHeight + 'px';
      this.style.overflow = 'hidden';
    }
  }
  
  expand() {
    const wrapper = this.querySelector('.new-additional-products-wrapper');
    if (!wrapper) return;
    
    this.isExpanded = true;
    wrapper.classList.add('expanded');
    
    // 移除高度限制
    this.style.maxHeight = 'none';
    this.style.overflow = 'hidden auto';
  }
  
  setupProductItem(item) {
    const selectBtn = item.querySelector('.product-select-btn');
    const variantSelect = item.querySelector('.variant-select');
    
    // 为整个产品项绑定点击事件
    item.addEventListener('click', (e) => {
      // 阻止点击选框和变体选择器时的默认行为
      if (e.target.closest('.product-select-btn') || e.target.closest('.variant-select')) {
        return;
      }
      this.toggleProductSelection(item);
    });

    // 为选择按钮绑定点击事件
    if (selectBtn) {
      selectBtn.addEventListener('click', (e) => {
        e.stopPropagation(); // 阻止冒泡到父元素
        this.toggleProductSelection(item);
      });
    }

    // 为变体选择器绑定变更事件
    if (variantSelect) {
      variantSelect.addEventListener('change', (e) => {
        e.stopPropagation(); // 阻止冒泡到父元素
        this.handleVariantChange(item, e.target);
      });
    }
  }

  toggleProductSelection(item) {
    const productData = this.getProductData(item);
    const isSelected = item.classList.contains('selected');
    
    if (isSelected) {
      // 取消选中
      item.classList.remove('selected');
      this.selectedProducts.delete(productData.id);
      this.updateSelectButton(item, false);
    } else {
      // 选中
      item.classList.add('selected');
      this.selectedProducts.add(productData.id);
      this.updateSelectButton(item, true);
    }

    // 触发自定义事件，通知其他组件
    this.dispatchEvent(new CustomEvent('selection-changed', {
      detail: {
        productId: productData.id,
        selected: !isSelected,
        selectedProducts: Array.from(this.selectedProducts)
      }
    }));

    // 重新检查是否需要显示渐变效果(表达可以往下滚动)
    setTimeout(() => {
      this.checkOverflowAndGradient();
    }, 0);
  }

  updateSelectButton(item, isSelected) {
    const unselectedIcon = item.querySelector('.unselected-icon');
    const selectedIcon = item.querySelector('.selected-icon');
    
    if (isSelected) {
      unselectedIcon.style.display = 'none';
      selectedIcon.style.display = 'block';
    } else {
      unselectedIcon.style.display = 'flex';
      selectedIcon.style.display = 'none';
    }
  }

  handleVariantChange(item, selectElement) {
    const selectedOption = selectElement.options[selectElement.selectedIndex];
    const productData = this.getProductData(item);
    
    // 获取变体数据
    const variantData = {
      id: selectedOption.value,
      price: selectedOption.dataset.price,
      comparePrice: selectedOption.dataset.comparePrice,
      image: selectedOption.dataset.image
    };

    // 更新产品显示信息
    this.updateProductDisplay(item, variantData, productData);
    
    // 触发变体变化事件，通知价格计算逻辑
    this.dispatchEvent(new CustomEvent('variant-changed', {
      detail: {
        productId: productData.id,
        variantId: variantData.id,
        variantData: variantData
      }
    }));
  }

  updateProductDisplay(item, variantData, productData) {
    // 更新图片
    const productImage = item.querySelector('.product-image img');
    if (productImage && variantData.image) {
      productImage.src = variantData.image;
    }

    // 更新价格
    const currentPriceElement = item.querySelector('.current-price');
    const comparePriceElement = item.querySelector('.compare-price');
    
    if (currentPriceElement) {
      const formattedPrice = this.formatPrice(variantData.price);
      currentPriceElement.textContent = `$${formattedPrice}`;
    }

    if (comparePriceElement) {
      const comparePrice = variantData.comparePrice;
      const price = variantData.price;
      
      // 检查 comparePrice 是否有效（不为 null、"null"、undefined 或空字符串）
      if (comparePrice && 
          comparePrice !== "null" && 
          comparePrice !== "" && 
          comparePrice !== null && 
          comparePrice !== "0" &&
          parseFloat(comparePrice) > 0 &&
          parseFloat(comparePrice) > parseFloat(price)) {
        const formattedComparePrice = this.formatPrice(comparePrice);
        comparePriceElement.textContent = `$${formattedComparePrice}`;
        comparePriceElement.style.display = 'inline';
      } else {
        comparePriceElement.style.display = 'none';
      }
    }
  }

  getProductData(item) {
    const dataScript = item.querySelector('.product-data');
    if (dataScript) {
      try {
        return JSON.parse(dataScript.textContent);
      } catch (e) {
        console.error('Error parsing product data:', e);
        return {};
      }
    }
    return {};
  }

  formatPrice(priceInCents) {
    return (parseFloat(priceInCents) / 100).toFixed(2);
  }

  // 检查是否需要显示渐变效果
  checkOverflowAndGradient() {
    const wrapper = this.querySelector('.new-additional-products-wrapper');
    if (!wrapper) return;

    const productsContainer = this.querySelector('.new-additional-products');
    if (!productsContainer) return;

    // 检查内容是否产生滚动
    const scrollHeight = productsContainer.scrollHeight;
    const clientHeight = productsContainer.clientHeight;
    const hasVerticalScroll = scrollHeight > clientHeight;
    
    if (hasVerticalScroll) {
      wrapper.classList.add('show-gradient');
    } else {
      wrapper.classList.remove('show-gradient');
    }
  }

  // 获取所有选中的产品信息
  getSelectedProducts() {
    const selectedItems = this.querySelectorAll('.new-additional-product-item.selected');
    return Array.from(selectedItems).map(item => {
      const productData = this.getProductData(item);
      const variantSelector = item.querySelector('.product-variant-selector');
      const variantSelect = (variantSelector && variantSelector.classList.contains('hidden')) ? null : item.querySelector('.variant-select');
      const selectedVariantId = variantSelect ? variantSelect.value : null;
      
      return {
        productId: productData.id,
        variantId: selectedVariantId,
        productData: productData
      };
    });
  }
}

if (!window.customElements.get('new-additional-products')) {
  customElements.define('new-additional-products', NewAdditionalProducts);
}

// 新的附加产品Tab容器组件 - 仅处理Tab切换，其他功能由NewAdditionalProducts处理
class NapTabsContainer extends HTMLElement {
  constructor() {
    super();
    this.activeTabIndex = 0;
  }

  connectedCallback() {
    this.tabButtons = this.querySelectorAll('.nap-tab-btn');
    this.tabPanels = this.querySelectorAll('.nap-tab-panel');
    
    this.tabButtons.forEach((btn, index) => {
      btn.addEventListener('click', () => this.switchTab(index));
    });
  }

  switchTab(index) {
    if (index === this.activeTabIndex) return;
    
    this.tabButtons.forEach((btn, i) => {
      btn.classList.toggle('active', i === index);
    });
    
    this.tabPanels.forEach((panel, i) => panel.classList.toggle('active', i === index));
    this.activeTabIndex = index;
  }
}

if (!window.customElements.get('nap-tabs-container')) {
  customElements.define('nap-tabs-container', NapTabsContainer);
}

// 新的附加产品组件
class TabAdditionalProducts extends HTMLElement {
  constructor() {
    super();
    this.selectedProducts = new Set(); // 存储选中的产品ID
    this.isExpanded = false; // 展开状态
    this.collapsedMaxHeight = null; // 收起时的最大高度
    this.singleSelectMode = false; // 单选模式
  }

  connectedCallback() {
    // 读取单选模式配置
    this.singleSelectMode = this.dataset.singleSelectMode === 'true';
    this.init();
    
    // 延迟检查溢出状态，确保DOM完全渲染
    setTimeout(() => {
      this.checkOverflowAndGradient();
      this.checkExpandCollapseNeeded();
    }, 100);
    
    // 监听窗口大小变化，重新检查溢出状态
    this.resizeObserver = new ResizeObserver(() => {
      this.checkOverflowAndGradient();
      this.checkExpandCollapseNeeded();
    });
    this.resizeObserver.observe(this);
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  init() {
    // 为每个产品项绑定点击事件
    this.querySelectorAll('.new-additional-product-item').forEach(item => {
      this.setupProductItem(item);
    });
    
    // 为展开/收起按钮绑定点击事件
    this.setupExpandCollapseButton();
    // 为Shuffle按钮绑定点击事件
    this.setupShuffleButton();
  }
  
  setupExpandCollapseButton() {
    const expandBtn = this.querySelector('.expand-collapse-btn');
    if (!expandBtn) return;
    
    expandBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      this.toggleExpandCollapse();
    });
  }

  setupShuffleButton() {
    const shuffleBtn = this.querySelector('.shuffle-btn');
    if (!shuffleBtn) return;

    shuffleBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      this.handleShuffle(shuffleBtn);
    });
  }

  async handleShuffle(btn) {
    if (this.isShuffling) return;
    this.isShuffling = true;
    btn.classList.add('rotating');

    try {
      this.shuffleProducts();
    } catch (e) {
      console.error('Shuffle error:', e);
    }

    setTimeout(() => {
      btn.classList.remove('rotating');
      this.isShuffling = false;
    }, 500);
  }

  shuffleProducts() {
    const poolScript = this.querySelector('.nap-data-pool');
    if (!poolScript) return;
    
    let poolData;
    try {
      poolData = JSON.parse(poolScript.textContent);
    } catch(e) {
      return;
    }

    const allProducts = poolData.products || [];
    const iconMap = poolData.icon_map || {};
    
    // 获取当前页面上存在的产品ID（包括选中的和未选中的）
    const currentItems = Array.from(this.querySelectorAll('.new-additional-product-item'));
    const currentIds = new Set();
    currentItems.forEach(item => {
      const data = this.getProductData(item);
      if (data && data.id) currentIds.add(data.id);
    });
    
    // 筛选出未选中的DOM元素（即需要被替换的位置）
    const candidates = currentItems.filter(item => !item.classList.contains('selected'));
    if (candidates.length === 0) return;

    // 从池子中筛选出不在当前页面上的产品
    const available = allProducts.filter(p => !currentIds.has(p.id));
    if (available.length === 0) return;

    // 加权随机打乱 (带有图标的产品权重更高)
    const shuffled = available.map(p => {
      // 检查是否有图标
      const hasIcon = !!iconMap[String(p.id)];
      // 权重: 有图标 1.3 (提升30%), 无图标 1.0
      const weight = hasIcon ? 30 : 1.0;
      // 使用加权随机分数 (Weighted Random Score)
      const score = Math.pow(Math.random(), 1 / weight);
      return { product: p, score: score };
    })
    .sort((a, b) => b.score - a.score)
    .map(item => item.product);

    // 替换逻辑
    candidates.forEach((item, index) => {
      if (index < shuffled.length) {
        this.replaceProductItem(item, shuffled[index], iconMap);
      }
    });
  }

  replaceProductItem(item, product, iconMap) {
    // 1. 更新 data-product-handle
    item.setAttribute('data-product-handle', product.handle);

    // 2. 更新 Corner Icon
    let cornerIcon = item.querySelector('.product-corner-icon');
    const iconUrl = iconMap[String(product.id)]; // Key is string in JSON
    
    if (iconUrl) {
      if (!cornerIcon) {
        cornerIcon = document.createElement('div');
        cornerIcon.className = 'product-corner-icon';
        const img = document.createElement('img');
        img.width = 60;
        img.height = 60; 
        img.loading = 'lazy';
        cornerIcon.appendChild(img);
        item.appendChild(cornerIcon);
      }
      const img = cornerIcon.querySelector('img');
      if (img) img.src = iconUrl;
      cornerIcon.style.display = 'block';
    } else {
      if (cornerIcon) cornerIcon.style.display = 'none';
    }

    // 3. 更新主图
    const mainImg = item.querySelector('.product-image img');
    if (mainImg) {
      mainImg.src = product.featured_image;
      mainImg.alt = product.title;
    }

    // 4. 更新标题
    const titleEl = item.querySelector('.product-title');
    if (titleEl) {
      titleEl.textContent = product.title;
    }

    // 5. 更新变体选择器
    const variantContainer = item.querySelector('.product-variant-selector');
    if (product.variants && product.variants.length > 1) {
      if (!variantContainer) {
        // 如果之前没有容器，创建一个，插入到 title 后面
        const newContainer = document.createElement('div');
        newContainer.className = 'product-variant-selector';
        const infoDiv = item.querySelector('.new-additional-product-info');
        if (infoDiv) {
            if (titleEl) {
                 infoDiv.insertBefore(newContainer, titleEl.nextSibling);
            } else {
                 infoDiv.appendChild(newContainer);
            }
        }
      }
      
      // 重新获取容器
      const container = item.querySelector('.product-variant-selector');
      if (container) {
        container.innerHTML = ''; // 清空
        container.classList.remove('hidden');
        container.style.display = ''; // 清除可能存在的内联样式
        const select = document.createElement('select');
        select.className = 'variant-select';
        select.name = `variant-${product.id}`;
        
        product.variants.forEach(v => {
          const opt = document.createElement('option');
          opt.value = v.id;
          opt.dataset.price = v.price;
          opt.dataset.comparePrice = v.compare_at_price || '';
          opt.dataset.image = v.image || '';
          opt.textContent = v.title;
          if (v.id === product.variants[0].id) opt.selected = true;
          select.appendChild(opt);
        });
        
        container.appendChild(select);
        
        // 重新绑定事件
        select.addEventListener('change', (e) => {
          e.stopPropagation();
          this.handleVariantChange(item, e.target);
        });
      }
    } else {
      if (variantContainer) {
        variantContainer.classList.add('hidden');
        variantContainer.style.display = ''; // 清除可能存在的内联样式
      }
    }

    // 6. 更新价格
    const currentPriceEl = item.querySelector('.current-price');
    if (currentPriceEl) {
      currentPriceEl.textContent = '$' + this.formatPrice(product.price);
    }
    
    const comparePriceEl = item.querySelector('.compare-price');
    if (comparePriceEl) {
      if (product.compare_at_price && product.compare_at_price > product.price) {
        comparePriceEl.textContent = '$' + this.formatPrice(product.compare_at_price);
        comparePriceEl.style.display = 'inline';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }

    // 7. 更新隐藏的数据 Script
    const scriptData = item.querySelector('.product-data');
    if (scriptData) {
      scriptData.textContent = JSON.stringify(product);
    }

    // 8. 确保状态为未选中
    item.classList.remove('selected');
    this.updateSelectButton(item, false);
    
    // 如果有变体，初始化显示
    if (product.variants && product.variants.length > 0) {
        const firstVariant = product.variants[0];
        const variantData = {
          id: firstVariant.id,
          price: firstVariant.price,
          comparePrice: firstVariant.compare_at_price,
          image: firstVariant.image
        };
        this.updateProductDisplay(item, variantData, product);
    }
  }
  
  checkExpandCollapseNeeded() {
    const items = this.querySelectorAll('.new-additional-product-item');
    
    const expandBtn = this.querySelector('.expand-collapse-line');
    if (!expandBtn) return;
    
    // 如果产品数量 >= 4，则显示展开/收起按钮
    if (items.length >= 4) {
      this.style.paddingBottom = '20px';
      // 计算前3个产品的总高度
      this.calculateCollapsedHeight(items);
      
      // 显示按钮
      expandBtn.style.display = 'flex';
      
      // 初始状态为收起
      if (!this.isExpanded) {
        this.collapse();
      }
    } else {
      // 产品少于4个，隐藏按钮，移除高度限制
      expandBtn.style.display = 'none';
      this.style.maxHeight = 'none';
      this.classList.remove('expanded');
    }
  }
  
  calculateCollapsedHeight(items) {
    // 计算前3个产品的总高度 + gap
    if (items.length < 3) return;
    
    let totalHeight = 0;
    const gap = 12; // gap between items
    
    for (let i = 0; i < 3; i++) {
      totalHeight += items[i].offsetHeight;
      if (i < 2) totalHeight += gap; // 添加gap，除了最后一个
    }
    
    // 添加padding-top
    totalHeight += 38; /* 多添加一点，因为tab型 布局变了 */
    
    this.collapsedMaxHeight = totalHeight;
  }
  
  toggleExpandCollapse() {
    if (this.isExpanded) {
      this.collapse();
    } else {
      this.expand();
    }
  }
  
  collapse() {
    this.isExpanded = false;
    this.classList.remove('expanded');
    
    // 设置最大高度为前3个产品的高度
    if (this.collapsedMaxHeight) {
      this.style.maxHeight = this.collapsedMaxHeight + 'px';
      this.style.overflow = 'hidden';
    }
  }
  
  expand() {
    this.isExpanded = true;
    this.classList.add('expanded');
    
    // 移除高度限制
    this.style.maxHeight = 'none';
    this.style.overflow = 'hidden auto';
  }
  
  setupProductItem(item) {
    const selectBtn = item.querySelector('.product-select-btn');
    const variantSelect = item.querySelector('.variant-select');
    
    // 为整个产品项绑定点击事件
    item.addEventListener('click', (e) => {
      // 阻止点击选框和变体选择器时的默认行为
      if (e.target.closest('.product-select-btn') || e.target.closest('.variant-select')) {
        return;
      }
      this.toggleProductSelection(item);
    });

    // 为选择按钮绑定点击事件
    if (selectBtn) {
      selectBtn.addEventListener('click', (e) => {
        e.stopPropagation(); // 阻止冒泡到父元素
        this.toggleProductSelection(item);
      });
    }

    // 为变体选择器绑定变更事件
    if (variantSelect) {
      variantSelect.addEventListener('change', (e) => {
        e.stopPropagation(); // 阻止冒泡到父元素
        this.handleVariantChange(item, e.target);
      });
    }
  }

  toggleProductSelection(item) {
    const productData = this.getProductData(item);
    const isSelected = item.classList.contains('selected');

    if (isSelected) {
      // 取消选中
      item.classList.remove('selected');
      this.selectedProducts.delete(productData.id);
      this.updateSelectButton(item, false);
    } else {
      // 单选模式：选中新产品前，先取消选中当前tab下的所有其他产品
      if (this.singleSelectMode) {
        this.querySelectorAll('.new-additional-product-item.selected').forEach(selectedItem => {
          const selectedProductData = this.getProductData(selectedItem);
          selectedItem.classList.remove('selected');
          this.selectedProducts.delete(selectedProductData.id);
          this.updateSelectButton(selectedItem, false);
        });
      }
      // 选中
      item.classList.add('selected');
      this.selectedProducts.add(productData.id);
      this.updateSelectButton(item, true);
    }

    // 触发自定义事件，通知其他组件
    this.dispatchEvent(new CustomEvent('selection-changed', {
      detail: {
        productId: productData.id,
        selected: !isSelected,
        selectedProducts: Array.from(this.selectedProducts)
      }
    }));

    // 重新检查是否需要显示渐变效果(表达可以往下滚动)
    setTimeout(() => {
      this.checkOverflowAndGradient();
    }, 0);
  }

  updateSelectButton(item, isSelected) {
    const unselectedIcon = item.querySelector('.unselected-icon');
    const selectedIcon = item.querySelector('.selected-icon');
    
    if (isSelected) {
      unselectedIcon.style.display = 'none';
      selectedIcon.style.display = 'block';
    } else {
      unselectedIcon.style.display = 'flex';
      selectedIcon.style.display = 'none';
    }
  }

  handleVariantChange(item, selectElement) {
    const selectedOption = selectElement.options[selectElement.selectedIndex];
    const productData = this.getProductData(item);
    
    // 获取变体数据
    const variantData = {
      id: selectedOption.value,
      price: selectedOption.dataset.price,
      comparePrice: selectedOption.dataset.comparePrice,
      image: selectedOption.dataset.image
    };

    // 更新产品显示信息
    this.updateProductDisplay(item, variantData, productData);
    
    // 触发变体变化事件，通知价格计算逻辑
    this.dispatchEvent(new CustomEvent('variant-changed', {
      detail: {
        productId: productData.id,
        variantId: variantData.id,
        variantData: variantData
      }
    }));
  }

  updateProductDisplay(item, variantData, productData) {
    // 更新图片
    const productImage = item.querySelector('.product-image img');
    if (productImage && variantData.image) {
      productImage.src = variantData.image;
    }

    // 更新价格
    const currentPriceElement = item.querySelector('.current-price');
    const comparePriceElement = item.querySelector('.compare-price');
    
    if (currentPriceElement) {
      const formattedPrice = this.formatPrice(variantData.price);
      currentPriceElement.textContent = `$${formattedPrice}`;
    }

    if (comparePriceElement) {
      const comparePrice = variantData.comparePrice;
      const price = variantData.price;
      
      // 检查 comparePrice 是否有效（不为 null、"null"、undefined 或空字符串）
      if (comparePrice && 
          comparePrice !== "null" && 
          comparePrice !== "" && 
          comparePrice !== null && 
          comparePrice !== "0" &&
          parseFloat(comparePrice) > 0 &&
          parseFloat(comparePrice) > parseFloat(price)) {
        const formattedComparePrice = this.formatPrice(comparePrice);
        comparePriceElement.textContent = `$${formattedComparePrice}`;
        comparePriceElement.style.display = 'inline';
      } else {
        comparePriceElement.style.display = 'none';
      }
    }
  }

  getProductData(item) {
    const dataScript = item.querySelector('.product-data');
    if (dataScript) {
      try {
        return JSON.parse(dataScript.textContent);
      } catch (e) {
        console.error('Error parsing product data:', e);
        return {};
      }
    }
    return {};
  }

  formatPrice(priceInCents) {
    return (parseFloat(priceInCents) / 100).toFixed(2);
  }

  // 检查是否需要显示渐变效果
  checkOverflowAndGradient() {
    const productsContainer = this.querySelector('.new-additional-products');
    if (!productsContainer) return;

    // 检查内容是否产生滚动
    const scrollHeight = productsContainer.scrollHeight;
    const clientHeight = productsContainer.clientHeight;
    const hasVerticalScroll = scrollHeight > clientHeight;
    
    if (hasVerticalScroll) {
      this.classList.add('show-gradient');
    } else {
      this.classList.remove('show-gradient');
    }
  }

  // 获取所有选中的产品信息
  getSelectedProducts() {
    const selectedItems = this.querySelectorAll('.new-additional-product-item.selected');
    return Array.from(selectedItems).map(item => {
      const productData = this.getProductData(item);
      const variantSelector = item.querySelector('.product-variant-selector');
      const variantSelect = (variantSelector && variantSelector.classList.contains('hidden')) ? null : item.querySelector('.variant-select');
      const selectedVariantId = variantSelect ? variantSelect.value : null;
      
      return {
        productId: productData.id,
        variantId: selectedVariantId,
        productData: productData
      };
    });
  }
}

// 注册自定义元素
if (!window.customElements.get('tab-additional-products')) {
  customElements.define('tab-additional-products', TabAdditionalProducts);
}

// Slideshow add to cart 自定义元素
class SlideshowAddToCart extends HTMLElement {
  constructor() {
    super();
    this.variantId = this.getAttribute('variant-id');
    this.quantity = parseInt(this.getAttribute('quantity')) || 1;
    this.isLoading = false;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    // 为整个元素绑定点击事件
    this.addEventListener('click', (e) => {
      // 阻止轮播图控制按钮的冲突
      if (e.target.closest('.slideshow__controls') || 
          e.target.closest('button[is="prev-button"]') || 
          e.target.closest('button[is="next-button"]') ||
          e.target.closest('.numbered-dots') ||
          e.target.closest('.stretching-dots')) {
        return;
      }
      
      e.preventDefault();
      e.stopPropagation();
      this.handleAddToCart();
    });
  }

  async handleAddToCart() {
    if (this.isLoading || !this.variantId) {
      return;
    }

    this.isLoading = true;

    try {
      const formData = {
        'items': [{
          'id': parseInt(this.variantId),
          'quantity': this.quantity
        }]
      };

      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // 显示购物车抽屉
      const event = new CustomEvent("cart:show");
      document.dispatchEvent(event);
      document.dispatchEvent(new CustomEvent("cart:refresh"));

    } catch (error) {
      console.error('Error adding to cart:', error);
    } finally {
      this.isLoading = false;
    }
  }
}

if (!window.customElements.get('slideshow-add-to-cart')) {
  customElements.define('slideshow-add-to-cart', SlideshowAddToCart);
}

class ImageLinkBlocksCarousel extends HTMLElement {
  constructor() {
    super();
    this._swiper = null;
  }
  connectedCallback() {
    this._initSwiper();
  }
  disconnectedCallback() {
    if (this._swiper && this._swiper.destroy) {
      this._swiper.destroy(true, true);
      this._swiper = null;
    }
  }
  _initSwiper() {
    const container = this.querySelector('.dev-image-link-swiper');
    if (!container || typeof Swiper === 'undefined') return;

    const isPhone = window.innerWidth <= 767;

    const pcShowNum = parseFloat(this.getAttribute('pc-show-num'));
    const h5ShowNum = parseFloat(this.getAttribute('h5-show-num'));
    const pcGap = parseInt(this.getAttribute('pc-picture-gap'));
    const h5Gap = parseInt(this.getAttribute('h5-picture-gap'));
    const interval = parseInt(this.getAttribute('carousel-interval'));
    const closeCarousel = this.getAttribute('close-carousel') === 'true';

    const slidesPerView = isPhone ? (isNaN(h5ShowNum) ? 1 : h5ShowNum) : (isNaN(pcShowNum) ? 1 : pcShowNum);
    const spaceBetween = isPhone ? (isNaN(h5Gap) ? 0 : h5Gap) : (isNaN(pcGap) ? 0 : pcGap);

    const config = {
      slidesPerView: slidesPerView,
      spaceBetween: spaceBetween,
      loop: true,
      grabCursor: true,
    };

    if (!closeCarousel) {
      config.autoplay = {
        delay: isNaN(interval) ? 4000 : interval,
        disableOnInteraction: false,
      };
    }

    this._swiper = new Swiper(container, config);
  }
}

if (!window.customElements.get('image-link-blocks-carousel')) {
  customElements.define('image-link-blocks-carousel', ImageLinkBlocksCarousel);
}


// Temp Famous Person：每个 tab 下的卡片轮播（Swiper，slidesPerView: auto 保持卡片尺寸与间距不变）
class FamousPersonCarousel extends HTMLElement {
  constructor() {
    super();
    this._swiper = null;
    this._onResize = this._onResize.bind(this);
  }

  connectedCallback() {
    this._init();
    window.addEventListener('resize', this._onResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this._onResize);
    if (this._swiper && this._swiper.destroy) {
      this._swiper.destroy(true, true);
      this._swiper = null;
    }
  }

  _onResize() {
    if (this._swiper && this._swiper.update) this._swiper.update();
  }

  _init() {
    if (this._swiper) return;
    const container = this.querySelector('.swiper');
    if (!container || typeof Swiper === 'undefined') return;

    const openCarousel = this.getAttribute('open-carousel') === 'true';
    const interval = parseInt(this.getAttribute('carousel-interval'), 10);

    // 间距与 CSS 变量 --famous-carousel-gap 保持一致
    let gap = parseFloat(getComputedStyle(this).getPropertyValue('--famous-carousel-gap'));
    if (isNaN(gap)) gap = 10;

    const config = {
      slidesPerView: 'auto',
      spaceBetween: gap,
      grabCursor: true,
      observer: true,
      observeParents: true,
      watchSlidesProgress: true,
    };

    if (openCarousel) {
      config.loop = true;
      config.autoplay = {
        delay: isNaN(interval) ? 4000 : interval,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    this._swiper = new Swiper(container, config);
  }
}

if (!window.customElements.get('famous-person-carousel')) {
  customElements.define('famous-person-carousel', FamousPersonCarousel);
}

// 自定义：折扣码复制横幅
class DiscountCodeBanner extends HTMLElement {
  constructor() {
    super();
    this._copyBtn = null;
    this._handleCopy = this._handleCopy.bind(this);
  }

  connectedCallback() {
    this._copyBtn = this.querySelector('.discount-banner__copy-btn');
    if (this._copyBtn) {
      this._copyBtn.addEventListener('click', this._handleCopy);
    }
  }

  disconnectedCallback() {
    if (this._copyBtn) {
      this._copyBtn.removeEventListener('click', this._handleCopy);
    }
  }

  async _handleCopy(event) {
    const btn = event.currentTarget;
    const discountCode = btn.getAttribute('data-discount-code');
    
    if (!discountCode) return;

    try {
      // 尝试使用现代 Clipboard API
      await navigator.clipboard.writeText(discountCode);
      this._showCopiedState(btn);
    } catch (err) {
      // 降级方案：使用 textarea 方法
      this._fallbackCopy(discountCode, btn);
    }
  }

  _fallbackCopy(text, btn) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      const successful = document.execCommand('copy');
      if (successful) {
        this._showCopiedState(btn);
      } else {
        console.error('Copy command failed');
      }
    } catch (err) {
      console.error('Failed to copy:', err);
    }
    
    document.body.removeChild(textArea);
  }

  _showCopiedState(btn) {
    // 添加 copied 状态
    btn.classList.add('copied');
    
    // 2.5秒后移除 copied 状态
    setTimeout(() => {
      btn.classList.remove('copied');
    }, 2500);
  }
}

if (!window.customElements.get('discount-code-banner')) {
  customElements.define('discount-code-banner', DiscountCodeBanner);
}

class OfpPrice extends HTMLElement {
  constructor() {
    super();
    this._onScroll = this._onScroll.bind(this);
    this._modalCalled = false;
    this._onGlobalBeginCountdown = this._onGlobalBeginCountdown.bind(this);
    this._countdownRAF = null;
    this._countdownEndTime = null;
    this._hasTriggeredModal = 0;
  }
  connectedCallback() {
    this._cacheEls();
    this._installments = parseInt(this.getAttribute('data-installments')) || 0;
    this._price = this._safeParseMoney(this.getAttribute('data-price'));
    this._comparePrice = this._safeParseMoney(this.getAttribute('data-compare-price'));
    this._savings = this._safeParseMoney(this.getAttribute('data-savings')) || 0;
    this._countdownMinutes = parseInt(this.getAttribute('data-countdown-minutes')) || 0;
    this._countdownLabel = this.getAttribute('data-countdown-label') || '';
    // 从 Local Storage 读取 modal 触发状态
    const productHandle = this._getProductHandle();
    if (productHandle) {
      const storageKey = productHandle + ' hasTriggeredModal';
      try {
        const storedValue = localStorage.getItem(storageKey);
        if (storedValue !== null) {
          this._hasTriggeredModal = parseInt(storedValue) || 0;
        }
      } catch (e) {
        console.error('Failed to read from localStorage:', e);
      }
    }
    
    // this.addEventListener('ofp:switch-to-final', () => this._switchToFinal()); 去掉价格滚动
    this.addEventListener('ofp:begin-countdown', (e) => this.beginCountdown((e && e.detail) || {}));
    document.addEventListener('ofp:begin-countdown', this._onGlobalBeginCountdown);
    window.addEventListener('scroll', this._onScroll, { passive: true });
    window.addEventListener('resize', this._onScroll);
    setTimeout(this._onScroll, 0);
  }
  disconnectedCallback() {
    window.removeEventListener('scroll', this._onScroll);
    window.removeEventListener('resize', this._onScroll);
    document.removeEventListener('ofp:begin-countdown', this._onGlobalBeginCountdown);
    if (this._countdownRAF) {
      cancelAnimationFrame(this._countdownRAF);
      this._countdownRAF = null;
    }
  }
  triggerModal() {
    const event = new CustomEvent("open-coupon-modal");
    const modal = document.querySelector('script-trigger-modal[listen-event="open-coupon-modal"]');
    modal.dispatchEvent(event);
    
    // 保存到 Local Storage
    const productHandle = this._getProductHandle();
    if (productHandle) {
      const storageKey = productHandle + ' hasTriggeredModal';
      try {
        localStorage.setItem(storageKey, '1');
        this._hasTriggeredModal = 1;
      } catch (e) {
        console.error('Failed to write to localStorage:', e);
      }
    }
  }
  _getProductHandle() {
    // 从 URL 中提取 product handle
    // 例如: http://127.5.3.5:9292/products/deerrun-plus-walkingpad-treadmill
    // 返回: deerrun-plus-walkingpad-treadmill
    const pathParts = window.location.pathname.split('/');
    const productsIndex = pathParts.indexOf('products');
    if (productsIndex !== -1 && pathParts.length > productsIndex + 1) {
      return pathParts[productsIndex + 1];
    }
    return null;
  }
  _cacheEls() {
    this.currentPriceEl = this.querySelector('.current-price');
    this.compareAtEl = this.querySelector('.compare-at-price');
    this.badgeEl = this.querySelector('.new-price-badge');
    this.installmentEl = this.querySelector('.installment-price');
    this.countdownLabelEl = this.querySelector('.countdown-label');
    this.countdownTimerEl = this.querySelector('.countdown-timer');
    this.countdownContainerEl = this.querySelector('.offer-countdown');
  }
  beginCountdown(options = {}) {
    if (!this.countdownTimerEl) return;
    
    // 获取倒计时分钟数和标签
    const minutes = typeof options.minutes === 'number' ? options.minutes : (parseInt(this._countdownMinutes) || 0);
    const label = options.label != null ? String(options.label) : (this._countdownLabel || '');
    
    // 设置标签文本
    if (this.countdownLabelEl && label) {
      this.countdownLabelEl.textContent = label;
    }
    
    // 如果分钟数无效，显示 00:00:00
    if (!minutes || minutes <= 0) {
      this.countdownTimerEl.textContent = '00 : 00 : 00';
      return;
    }
    
    // 清除旧的倒计时
    if (this._countdownRAF) {
      cancelAnimationFrame(this._countdownRAF);
      this._countdownRAF = null;
    }
    
    // 计算结束时间
    this._countdownEndTime = Date.now() + minutes * 60 * 1000;
    
    // 补零函数
    const pad = (n) => String(n).padStart(2, '0');
    
    // 更新倒计时显示
    const updateCountdown = () => {
      const remainMs = Math.max(0, this._countdownEndTime - Date.now());
      const totalSec = Math.floor(remainMs / 1000);
      
      const hours = Math.floor(totalSec / 3600);
      const minutes = Math.floor((totalSec % 3600) / 60);
      const seconds = totalSec % 60;
      
      this.countdownTimerEl.textContent = `${pad(hours)} : ${pad(minutes)} : ${pad(seconds)}`;
      
      // 如果倒计时未结束，继续下一帧
      if (remainMs > 0) {
        this._countdownRAF = requestAnimationFrame(updateCountdown);
      } else {
        this._countdownRAF = null;
        // 倒计时结束，隐藏倒计时容器
        if (this.countdownContainerEl) {
          this.countdownContainerEl.classList.add('hidden');
        }
      }
    };
    
    // 立即执行一次并开始循环
    updateCountdown();
  }

  _onGlobalBeginCountdown(e) {
    const detail = (e && e.detail) || {};
    const sectionId = this.getAttribute('data-section-id');
    if (!detail.sectionId || detail.sectionId === sectionId) {
      this.countdownContainerEl.classList.remove('hidden');
      this.beginCountdown(detail);
    }
  }
  _onScroll() {
    if (this._modalCalled || !this.currentPriceEl) return;
    const rect = this.currentPriceEl.getBoundingClientRect();
    const centerY = window.innerHeight / 2;
    const centerVisible = rect.top - 100 <= centerY;
    if(this._hasTriggeredModal === 0) { // 因为centerVisible值不稳定，所以不能&&一起判断
      if (centerVisible) {
        this._modalCalled = true;
        try { this.triggerModal(); } catch (e) {}
      }
    } else {
      // this._switchToFinal(); 去掉价格滚动
    }
  }
  _switchToFinal() {
    if (!this.currentPriceEl) return;
    const fromCurrent = this._getDisplayedNumber(this.currentPriceEl);
    if (this._price != null) {
      this._animateMoney(this.currentPriceEl, fromCurrent, this._price, { prefix: '$' });
    }
    if (this.compareAtEl) {
      this.compareAtEl.classList.remove('hidden');
    }
    if (this.badgeEl) {
      const badgeFrom = this._extractNumberFromText(this.badgeEl.textContent);
      this.badgeEl.style.marginTop = '0px';
      this._animateMoney(this.badgeEl, badgeFrom, this._savings, { prefix: '$', suffix: ' OFF', decimals: 0 });
    }
    if (this.installmentEl) {
      const fromInstallment = this._getDisplayedNumber(this.installmentEl);
      const targetInstallment = (this._installments > 0 && this._price != null)
        ? Math.round((this._price * 100) / this._installments) / 100
        : (this._price != null ? this._price : fromInstallment);
      const hasMo = /\/mo\b/.test(this.installmentEl.textContent);
      this._animateMoney(this.installmentEl, fromInstallment, targetInstallment, { prefix: '$', suffix: hasMo ? '/mo' : '' });
    }
  }
  _safeParseMoney(val) {
    if (val == null || val === '' || val === 'null' || val === 'undefined') return null;
    const num = parseFloat(val);
    if (isNaN(num)) return null;
    return num / 100;
  }
  _getDisplayedNumber(el) {
    const text = (el && el.textContent ? el.textContent : '').replace(/[^\d.,-]/g, '').replace(/,/g, '');
    const n = parseFloat(text);
    return isNaN(n) ? 0 : n;
  }
  _extractNumberFromText(text) {
    if (!text) return 0;
    const t = String(text).replace(/[^\d.,-]/g, '').replace(/,/g, '');
    const n = parseFloat(t);
    return isNaN(n) ? 0 : n;
  }
  _formatMoney(val, decimals = 2) {
    const n = typeof val === 'number' ? val : parseFloat(val) || 0;
    return n.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
  }
  _animateMoney(el, from, to, opts = {}) {
    const prefix = opts.prefix || '';
    const suffix = opts.suffix || '';
    const decimals = Number.isInteger(opts.decimals) ? opts.decimals : 2;
    if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
      el.textContent = prefix + this._formatMoney(to, decimals) + suffix;
      return;
    }
    const start = performance.now();
    const duration = 700;
    const animate = (now) => {
      const p = Math.min(1, (now - start) / duration);
      const val = from + (to - from) * p;
      el.textContent = prefix + this._formatMoney(val, decimals) + suffix;
      if (p < 1) requestAnimationFrame(animate);
    };
    requestAnimationFrame(animate);
  }
}

if (!window.customElements.get('ofp-price')) {
  customElements.define('ofp-price', OfpPrice);
}

// 顶部固定锚点条 - 单个锚点项
//! 该功能，需要注意的是稳定性处理，避免：运营填入的单个信息错误，执行代码报错，继而导致整个锚点条top值未设置上。
class HeaderAnchorItem extends HTMLElement {
  constructor() {
    super();
    this.selectorStr = this.getAttribute("selector-str");
    this.nthDom = parseInt(this.getAttribute("nth-dom")) || 1;
    this.rewriteId = this.getAttribute("rewrite-id");
    this.headerAnchorContainer = this.closest('header-anchor-container');
    this.targetDom = null; // 目标dom元素
    this.targetDomIdAttr = ""; // 目标dom元素的id值
  }
  connectedCallback() {
    this.init();
  }
  init() {
    this.targetDom = this.getTargetDom();
    if (!this.targetDom) {
      return;
    }
    
    if (this.rewriteId) {
      this.rewriteDomId();
    }
    
    // 获取并存储目标DOM的id属性值
    this.targetDomIdAttr = this.targetDom.getAttribute("id") || "";
    
    this.rewriteAEle();
  }

  getTargetDom() {
    try {
      if (this.nthDom - 1 < 0) return null;
      
      // 分两步处理：先查询所有元素，再获取指定索引的元素
      const allElements = document.querySelectorAll(`${this.selectorStr}`);
      if (!allElements || allElements.length === 0) return null;
      
      const targetDom = allElements[this.nthDom - 1];
      return targetDom || null;
    } catch (error) {
      console.error('Error in getTargetDom:', error);
      return null;
    }
  }

  rewriteDomId() {
    this.targetDom.setAttribute('id', this.rewriteId);
  }

  rewriteAEle() {
    const aEle = this.querySelector("a");
    const targetDomId = this.targetDom.getAttribute("id");
    if (!aEle || !targetDomId) {
      return;
    }
    aEle.setAttribute("href", `#${targetDomId}`);
  }
}

if (!window.customElements.get("header-anchor-item")) {
  customElements.define("header-anchor-item", HeaderAnchorItem);
}

// 顶部固定锚点条 - 容器（负责滚动追踪和固定定位）
//! 该功能，需要注意的是稳定性处理，避免：运营填入的单个信息错误，执行代码报错，继而导致整个锚点条top值未设置上。
class HeaderAnchorContainer extends HTMLElement {
  constructor() {
    super();
    this.hadFixedTopClassArr = this.getAttribute("had-fixed-top-class-arr");
    this.dynamicFixedTopSelectorArr = this.getAttribute("dynamic-fixed-top-selector-arr");
    this.observer = null;
    this.resizeObserver = null;
  }
  connectedCallback() {
    this.init();
  }
  init() {
    this.setupScrollTracking();
    this.setFixedTopPosition();
    this.setupDynamicElementObserver();
  }
  
  /* 监听动态插件元素的出现，并重新计算top值 */
  setupDynamicElementObserver() {
    if (!this.dynamicFixedTopSelectorArr) return;
    
    const selectorArr = this.dynamicFixedTopSelectorArr.split(',').map(s => s.trim()).filter(Boolean);
    if (selectorArr.length === 0) return;
    
    const pendingSelectorSet = new Set(selectorArr);
    const observedElementSet = new Set();
    const stopObservers = () => {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
    };
    const completeSelector = (selector) => {
      if (!pendingSelectorSet.delete(selector)) return;

      this.setFixedTopPosition();
      if (pendingSelectorSet.size === 0) {
        stopObservers();
      }
    };

    this.resizeObserver = new ResizeObserver(entries => {
      entries.forEach(entry => {
        if (entry.target.getBoundingClientRect().height <= 0) return;

        pendingSelectorSet.forEach(selector => {
          if (entry.target.matches(selector)) {
            completeSelector(selector);
          }
        });
      });
    });

    const checkDynamicElements = () => {
      pendingSelectorSet.forEach(selector => {
        const element = document.querySelector(selector);
        if (!element) return;

        if (element.getBoundingClientRect().height > 0) {
          completeSelector(selector);
        } else if (!observedElementSet.has(element)) {
          observedElementSet.add(element);
          this.resizeObserver.observe(element);
        }
      });
    };

    // 使用MutationObserver监听尚未插入DOM的动态插件元素
    this.observer = new MutationObserver(checkDynamicElements);
    this.observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // 初始检查一次，同时保留对延时出现、延时完成布局元素的监听
    setTimeout(checkDynamicElements, 500);
  }
  
  disconnectedCallback() {
    // 清理observer
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  }

  /* 设置滚动追踪(当滚动到某个section时，对应的锚点项会高亮) */
  setupScrollTracking() {
    const allItems = Array.from(this.querySelectorAll('header-anchor-item'));
    
    // 获取所有目标元素
    const targetElements = allItems.map(item => {
      try {
        const selectorStr = item.getAttribute("selector-str");
        const nthDom = parseInt(item.getAttribute("nth-dom")) || 1;
        const elements = document.querySelectorAll(selectorStr);
        return elements[nthDom - 1];
      } catch (error) {
        console.error('Error querying selector in setupScrollTracking:', error);
        return null;
      }
    }).filter(Boolean);

    const calculateActive = () => {
      const viewportHeight = window.innerHeight;
      // 屏幕底部上方30%的位置
      const triggerPoint = viewportHeight * 0.6; // 底部上方30% = 从顶部算70%
      
      let currentId = '';
      
      // 找到当前滚动位置对应的section
      // 从后往前遍历，找到第一个顶部位置在触发点之上的元素
      for (let i = targetElements.length - 1; i >= 0; i--) {
        const element = targetElements[i];
        const rect = element.getBoundingClientRect();
        const elementTop = rect.top;
        
        // 如果元素顶部已经到达或超过触发点（在触发点上方）
        if (elementTop <= triggerPoint) {
          currentId = element.getAttribute('id');
          break;
        }
      }

      // 更新所有链接的active状态
      allItems.forEach((item) => {
        item.classList.remove('active');
        if (item.querySelector('a')?.getAttribute('href')?.substring(1) === currentId) {
          item.classList.add('active');
        }
      });
    };

    window.addEventListener('scroll', calculateActive);
    calculateActive();
  }

  setFixedTopPosition() {
    const section = this.closest('[id^="shopify-section-"]');
    if (!section) return;

    let topValue = 0;
    
    // 计算hadFixedTopClassArr的高度
    if (this.hadFixedTopClassArr) {
      const classArr = this.hadFixedTopClassArr.split(',').map(c => c.trim()).filter(Boolean);
      topValue += classArr.reduce((prev, item) => {
        let height = 0;
        const element = document.querySelector(item);
        if (element) {
          height = element.clientHeight;
        }
        return prev + height;
      }, 0);
    }
    
    // 计算dynamicFixedTopSelectorArr的高度
    if (this.dynamicFixedTopSelectorArr) {
      const dynamicArr = this.dynamicFixedTopSelectorArr.split(',').map(s => s.trim()).filter(Boolean);
      topValue += dynamicArr.reduce((prev, selector) => {
        let height = 0;
        const element = document.querySelector(selector);
        if (element) {
          height = element.getBoundingClientRect().height;
        }
        return prev + height;
      }, 0);
    }

    section.style.top = topValue + 'px';
  }
}

if (!window.customElements.get("header-anchor-container")) {
  customElements.define("header-anchor-container", HeaderAnchorContainer);
}

// Custom: Tab Product Showcase Logic
class ProductTabs extends HTMLElement {
  constructor() {
    super();
    this.updateIndicator = this.updateIndicator.bind(this);
  }

  connectedCallback() {
    this.tabs = this.querySelectorAll('.tab-nav-item');
    this.panels = this.querySelectorAll('.tab-panel');
    this.indicator = this.querySelector('.tab-indicator');
    
    // Initialize indicator position
    const initialActive = this.querySelector('.tab-nav-item.active');
    if (initialActive) {
      // Use requestAnimationFrame and setTimeout to ensure accurate layout
      requestAnimationFrame(() => this.updateIndicator(initialActive));
      setTimeout(() => this.updateIndicator(initialActive), 100);
    }

    this.tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        // Remove active class from all
        this.tabs.forEach(t => t.classList.remove('active'));
        this.panels.forEach(p => p.classList.remove('active'));

        // Add active to clicked
        tab.classList.add('active');
        
        // Update indicator position
        this.updateIndicator(tab);

        const targetId = tab.getAttribute('data-tab-target');
        const targetPanel = document.getElementById(targetId);
        if (targetPanel) {
            targetPanel.classList.add('active');
            // Trigger resize event to ensure scroll area recalculates if needed
            window.dispatchEvent(new Event('resize'));
        }
      });
    });

    // Handle resize
    window.addEventListener('resize', () => {
      const active = this.querySelector('.tab-nav-item.active');
      if (active) this.updateIndicator(active);
    });
  }

  updateIndicator(activeTab) {
    if (!activeTab || !this.indicator) return;
    this.indicator.style.width = `${activeTab.offsetWidth}px`;
    this.indicator.style.left = `${activeTab.offsetLeft}px`;
  }
}

if (!window.customElements.get("product-tabs")) {
  customElements.define("product-tabs", ProductTabs);
}

// Scene Tab Product：tab 切换 + 移动端场景图同步切换
class SceneTabProduct extends HTMLElement {
  constructor() {
    super();
    this.updateIndicator = this.updateIndicator.bind(this);
  }

  connectedCallback() {
    this.tabs = this.querySelectorAll('.tab-nav-item');
    this.panels = this.querySelectorAll('.tab-panel');
    this.sceneItems = this.querySelectorAll('.scene-mobile-item');
    this.indicator = this.querySelector('.tab-indicator');

    // Initialize indicator position
    const initialActive = this.querySelector('.tab-nav-item.active');
    if (initialActive) {
      requestAnimationFrame(() => this.updateIndicator(initialActive));
      setTimeout(() => this.updateIndicator(initialActive), 100);
    }

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        // Remove active class from all
        this.tabs.forEach((t) => t.classList.remove('active'));
        this.panels.forEach((p) => p.classList.remove('active'));

        // Add active to clicked
        tab.classList.add('active');
        this.updateIndicator(tab);

        const targetId = tab.getAttribute('data-tab-target');
        const targetPanel = document.getElementById(targetId);
        if (targetPanel) {
          targetPanel.classList.add('active');
        }

        // Sync the mobile scene image above the tabs
        this.sceneItems.forEach((item) => {
          item.classList.toggle('active', item.getAttribute('data-scene-for') === targetId);
        });

        // Trigger resize so the scroll area recalculates if needed
        window.dispatchEvent(new Event('resize'));
      });
    });

    // Handle resize
    window.addEventListener('resize', () => {
      const active = this.querySelector('.tab-nav-item.active');
      if (active) this.updateIndicator(active);
    });
  }

  updateIndicator(activeTab) {
    if (!activeTab || !this.indicator) return;
    this.indicator.style.width = `${activeTab.offsetWidth}px`;
    this.indicator.style.left = `${activeTab.offsetLeft}px`;
  }
}

if (!window.customElements.get("scene-tab-product")) {
  customElements.define("scene-tab-product", SceneTabProduct);
}

// 倒计时自定义元素
class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.totalSeconds = 0;
    this.intervalId = null;
    this.isRunning = false;
  }

  connectedCallback() {
    this.init();
    this.startCountdown();
  }

  disconnectedCallback() {
    this.stopCountdown();
  }

  init() {
    // 从属性中获取配置
    const minutes = parseInt(this.getAttribute('minutes')) || 0;
    const seconds = parseInt(this.getAttribute('seconds')) || 0;
    this.totalSeconds = (minutes * 60) + seconds;
    
    // 获取DOM元素
    this.minutesElement = this.querySelector('.countdown-minutes');
    this.secondsElement = this.querySelector('.countdown-seconds');
    
    // 初始化显示
    this.updateDisplay();
  }

  startCountdown() {
    if (this.isRunning || this.totalSeconds <= 0) {
      return;
    }
    
    this.isRunning = true;
    this.intervalId = setInterval(() => {
      this.totalSeconds--;
      this.updateDisplay();
      
      if (this.totalSeconds <= 0) {
        this.stopCountdown();
        this.onCountdownEnd();
      }
    }, 1000);
  }

  stopCountdown() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    this.isRunning = false;
  }

  updateDisplay() {
    const minutes = Math.floor(this.totalSeconds / 60);
    const seconds = this.totalSeconds % 60;
    
    if (this.minutesElement) {
      this.minutesElement.textContent = this.formatTime(minutes);
    }
    
    if (this.secondsElement) {
      this.secondsElement.textContent = this.formatTime(seconds);
    }
  }

  formatTime(time) {
    return time.toString().padStart(2, '0');
  }

  onCountdownEnd() {
    // 倒计时结束时的处理
    this.classList.add('countdown-ended');
    
    // 触发自定义事件
    this.dispatchEvent(new CustomEvent('countdown-end', {
      detail: {
        element: this
      }
    }));
    
    // 可以在这里添加倒计时结束后的逻辑
    // 例如：重新开始倒计时、隐藏元素等
    setTimeout(() => {
      this.restartCountdown();
    }, 1000);
  }

  restartCountdown() {
    // 重新获取配置并重启倒计时
    const minutes = parseInt(this.getAttribute('minutes')) || 0;
    const seconds = parseInt(this.getAttribute('seconds')) || 0;
    this.totalSeconds = (minutes * 60) + seconds;
    this.classList.remove('countdown-ended');
    this.updateDisplay();
    this.startCountdown();
  }

  // 公共方法：手动设置倒计时
  setCountdown(minutes, seconds = 0) {
    this.stopCountdown();
    this.totalSeconds = (minutes * 60) + seconds;
    this.updateDisplay();
    this.startCountdown();
  }

  // 公共方法：获取剩余时间
  getRemainingTime() {
    return {
      total: this.totalSeconds,
      minutes: Math.floor(this.totalSeconds / 60),
      seconds: this.totalSeconds % 60
    };
  }
}

// 注册倒计时自定义元素
if (!window.customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}

// Custom: Chat Widget Trigger
class ChatWidgetTrigger extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.pollInterval = null;
    this.pollStartTime = 0;
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
    
    // 检查容器是否已存在
    const container = document.querySelector('body > #chat-widget-container');
    if (container) {
      this.startPolling();
    } else {
      this.initObserver();
    }
  }

  handleClick() {
    try {
      if (typeof LiveChatWidget !== 'undefined') {
        // 1. 先添加 class 让 CSS 使得容器可见 (opacity: 1)
        document.body.classList.add('livechat-open');
        
        // 2. 紧接着调用 API 打开聊天窗
        // 使用 requestAnimationFrame 确保 CSS 渲染周期已介入，虽然通常直接调用也行
        requestAnimationFrame(() => {
            LiveChatWidget.call('maximize');
        });
      }
    } catch (error) {
      console.error("尝试打开 LiveChat 失败:", error);
    }
  }

  initObserver() {
    this.observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          for (const node of mutation.addedNodes) {
             // 监测 LiveChat 容器被插入 DOM
             if (node.id === 'chat-widget-container') {
               if(this.observer) this.observer.disconnect();
               this.startPolling();
               return;
             }
          }
        }
      }
    });
    
    // 监听 body 子元素变化
    this.observer.observe(document.body, { childList: true });
  }
  
  startPolling() {
     this.pollStartTime = Date.now();
     
     // 立即检查一次
     if (this.checkLiveChatWidget()) return;

     // 轮询检查 LiveChatWidget 对象是否挂载到 window
     this.pollInterval = setInterval(() => {
        if (this.checkLiveChatWidget()) {
           clearInterval(this.pollInterval);
           return;
        }
        
        // 超时停止（4秒）
        if (Date.now() - this.pollStartTime > 4000) {
           clearInterval(this.pollInterval);
        }
     }, 100);
  }

  checkLiveChatWidget() {
     if (typeof LiveChatWidget !== 'undefined') {
        
        // 当 LiveChat 准备就绪
        LiveChatWidget.on('ready', () => {
           // 1. 显示你的自定义按钮 (移除 hidden 类)
           this.classList.remove('hidden');
           
           // 2. 虽然 CSS 已经隐藏了它，但我们仍需调用 hide API
           // 作用：告诉 LiveChat 内部逻辑“现在是隐藏状态”，防止它发出弹窗提示音或误判
           LiveChatWidget.call('hide');
        });

        // 监听状态变化（处理用户点击关闭/最小化按钮）
        LiveChatWidget.on('visibility_changed', (data) => {
           if (data.visibility === 'minimized') {
               // 1. 移除 body 类 -> CSS 瞬间将 opacity 设为 0 (解决关闭时的闪烁)
               document.body.classList.remove('livechat-open');
               
               // 2. 同步 API 状态，保持逻辑一致
               LiveChatWidget.call('hide');
           }
        });
        
        return true;
     }
     return false;
  }
  
  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    if (this.observer) this.observer.disconnect();
    if (this.pollInterval) clearInterval(this.pollInterval);
  }
}

// 注册 Web Component
if (!window.customElements.get('chat-widget-trigger')) {
  customElements.define('chat-widget-trigger', ChatWidgetTrigger);
}

// Custom: Order Support Chat Trigger
class OrderSupportChatTrigger extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);

    if (document.querySelector('body > #chat-widget-container')) {
      this.onWidgetReady();
    } else {
      this.observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          for (const node of mutation.addedNodes) {
            if (node.id === 'chat-widget-container') {
              this.observer.disconnect();
              this.observer = null;
              this.onWidgetReady();
              return;
            }
          }
        }
      });
      this.observer.observe(document.body, { childList: true });
    }
  }

  onWidgetReady() {
    this.classList.remove('hidden');
  }

  handleClick() {
    try {
      if (typeof LiveChatWidget !== 'undefined') {
        document.body.classList.add('livechat-open');
        requestAnimationFrame(() => {
          LiveChatWidget.call('maximize');
        });
      }
    } catch (error) {
      console.error('OrderSupportChatTrigger: failed to open LiveChat', error);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}

if (!window.customElements.get('order-support-chat-trigger')) {
  customElements.define('order-support-chat-trigger', OrderSupportChatTrigger);
}

class PopularQuestions extends HTMLElement {
  constructor() {
    super();
    this.handleTabClick = this.handleTabClick.bind(this);
    this.handleQuestionClick = this.handleQuestionClick.bind(this);
  }

  connectedCallback() {
    this.querySelectorAll('[data-popular-questions-tab]').forEach((tab) => {
      tab.addEventListener('click', this.handleTabClick);
    });

    this.querySelectorAll('[data-popular-questions-question]').forEach((question) => {
      question.addEventListener('click', this.handleQuestionClick);
    });
  }

  disconnectedCallback() {
    this.querySelectorAll('[data-popular-questions-tab]').forEach((tab) => {
      tab.removeEventListener('click', this.handleTabClick);
    });

    this.querySelectorAll('[data-popular-questions-question]').forEach((question) => {
      question.removeEventListener('click', this.handleQuestionClick);
    });
  }

  handleTabClick(event) {
    const activeTab = event.currentTarget;
    const panelId = activeTab.dataset.panelId;
    const activePanel = panelId ? this.querySelector(`#${CSS.escape(panelId)}`) : null;

    if (!activePanel) return;

    this.querySelectorAll('[data-popular-questions-tab]').forEach((tab) => {
      const isActive = tab === activeTab;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.querySelectorAll('[data-popular-questions-panel]').forEach((panel) => {
      panel.classList.toggle('is-active', panel === activePanel);
    });
  }

  handleQuestionClick(event) {
    const question = event.currentTarget;
    const item = question.closest('[data-popular-questions-item]');

    if (!item) return;

    const isOpen = item.classList.toggle('is-open');
    question.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }
}

if (!window.customElements.get('popular-questions')) {
  customElements.define('popular-questions', PopularQuestions);
}

class TagRowV2 extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector('.tag-row-container');
    this.indicator = this.querySelector('.scroll-indicator');
    this.isOneRow = this.getAttribute('data-one-row') === 'true';

    this.supportsMouseDrag = !!(window.matchMedia && window.matchMedia('(pointer: fine)').matches);
    this.isHovered = false;
    this.isPointerDown = false;
    this.isDragging = false;
    this.dragStartX = 0;
    this.dragStartScrollLeft = 0;

    this.boundHandleScroll = this.handleScroll.bind(this);
    this.boundHandleMouseEnter = this.handleMouseEnter.bind(this);
    this.boundHandleMouseLeave = this.handleMouseLeave.bind(this);
    this.boundHandleMouseDown = this.handleMouseDown.bind(this);
    this.boundHandleMouseMove = this.handleMouseMove.bind(this);
    this.boundHandleMouseUp = this.handleMouseUp.bind(this);
    this.boundHandleClickCapture = this.handleClickCapture.bind(this);
    this.boundHandleIndicatorClick = this.handleIndicatorClick.bind(this);
  }

  connectedCallback() {
    if (this.isOneRow && this.container) {
      // 初始化检查是否溢出
      this.checkOverflow();
      
      // 监听窗口大小变化重新检查
      window.addEventListener('resize', this.boundCheckOverflow);
      
      // 监听滚动事件
      this.container.addEventListener('scroll', this.boundHandleScroll, { passive: true });

      if (this.indicator) {
        this.indicator.addEventListener('click', this.boundHandleIndicatorClick);
      }

      // PC 端：鼠标悬停出现抓手，并支持按住拖动横向滚动
      if (this.supportsMouseDrag) {
        this.container.addEventListener('mouseenter', this.boundHandleMouseEnter);
        this.container.addEventListener('mouseleave', this.boundHandleMouseLeave);
        this.container.addEventListener('mousedown', this.boundHandleMouseDown);
        // 捕获阶段拦截：拖动过就不触发 a 链接跳转
        this.container.addEventListener('click', this.boundHandleClickCapture, true);
      }
    }
  }

  disconnectedCallback() {
    if (this.isOneRow) {
      window.removeEventListener('resize', this.boundCheckOverflow);
    }

    if (this.container) {
      this.container.removeEventListener('scroll', this.boundHandleScroll);
      if (this.supportsMouseDrag) {
        this.container.removeEventListener('mouseenter', this.boundHandleMouseEnter);
        this.container.removeEventListener('mouseleave', this.boundHandleMouseLeave);
        this.container.removeEventListener('mousedown', this.boundHandleMouseDown);
        this.container.removeEventListener('click', this.boundHandleClickCapture, true);
      }
    }

    if (this.indicator) {
      this.indicator.removeEventListener('click', this.boundHandleIndicatorClick);
    }

    document.removeEventListener('mousemove', this.boundHandleMouseMove);
    document.removeEventListener('mouseup', this.boundHandleMouseUp);
  }

  // 绑定 resize 上下文
  boundCheckOverflow = () => {
    this.checkOverflow();
  }

  checkOverflow() {
    if (!this.container) return;
    if (!this.indicator) return;

    // scrollWidth > clientWidth 说明内容溢出
    const isOverflowing = this.container.scrollWidth > this.container.clientWidth;

    if (this.supportsMouseDrag && this.isHovered && !this.isPointerDown) {
      this.container.style.cursor = isOverflowing ? 'grab' : '';
    }
    
    // 只有当溢出且用户还没滚动过(indicator没有被标记为scrolled)时显示
    if (isOverflowing && !this.indicator.classList.contains('has-scrolled')) {
      this.indicator.classList.remove('hidden');
    } else {
      this.indicator.classList.add('hidden');
    }
  }

  handleScroll() {
    if (!this.indicator) return;

    // 用户一旦滑动一下，该指示就消失，不再出现
    // 添加一个 has-scrolled 标记，防止 resize 再次触发显示
    this.indicator.classList.add('hidden');
    this.indicator.classList.add('has-scrolled');
  }

  handleIndicatorClick(e) {
    if (!this.indicator) return;
    e.preventDefault();
    e.stopPropagation();
    this.indicator.classList.add('hidden');
    this.indicator.classList.add('has-scrolled');
  }

  handleMouseEnter() {
    this.isHovered = true;
    this.checkOverflow();
  }

  handleMouseLeave() {
    this.isHovered = false;
    if (!this.isPointerDown && this.container) {
      this.container.style.cursor = '';
    }
  }

  handleMouseDown(e) {
    if (!this.container) return;
    if (e.button !== 0) return;

    const isOverflowing = this.container.scrollWidth > this.container.clientWidth;
    if (!isOverflowing) return;

    this.isPointerDown = true;
    this.isDragging = false;
    this.dragStartX = e.pageX;
    this.dragStartScrollLeft = this.container.scrollLeft;

    this.container.style.cursor = 'grabbing';
    this.container.style.userSelect = 'none';

    document.addEventListener('mousemove', this.boundHandleMouseMove);
    document.addEventListener('mouseup', this.boundHandleMouseUp);

    e.preventDefault();
  }

  handleMouseMove(e) {
    if (!this.container) return;
    if (!this.isPointerDown) return;

    const dx = e.pageX - this.dragStartX;
    if (Math.abs(dx) > 3) this.isDragging = true;
    this.container.scrollLeft = this.dragStartScrollLeft - dx;

    if (this.isDragging) e.preventDefault();
  }

  handleMouseUp() {
    if (!this.container) return;
    if (!this.isPointerDown) return;

    this.isPointerDown = false;
    document.removeEventListener('mousemove', this.boundHandleMouseMove);
    document.removeEventListener('mouseup', this.boundHandleMouseUp);

    this.container.style.userSelect = '';

    const isOverflowing = this.container.scrollWidth > this.container.clientWidth;
    this.container.style.cursor = (this.isHovered && isOverflowing) ? 'grab' : '';
  }

  handleClickCapture(e) {
    if (!this.isDragging) return;
    e.preventDefault();
    e.stopPropagation();
    this.isDragging = false;
  }
}

// 注册 Web Component
if (!window.customElements.get('tag-row-v2')) {
  customElements.define('tag-row-v2', TagRowV2);
}

class ProductFilterSection extends HTMLElement {
  constructor() {
    super();
    this.products = [];
    this.config = {};
    this.activeFilters = {}; 
  }

  connectedCallback() {
    // 1. 初始化数据
    try {
      const dataScript = this.querySelector('#product-data-pool');
      const configScript = this.querySelector('#config-data');
      if (dataScript) this.products = JSON.parse(dataScript.textContent);
      if (configScript) this.config = JSON.parse(configScript.textContent);
      
      // 数据预处理
      this.products = this.products.map(p => {
          let flatDisplay = [];
          p.display_tags.forEach(t => {
              if(t) t.split(';').forEach(sub => flatDisplay.push(sub.trim()));
          });
          
          let flatFilter = [];
          p.filter_tags.forEach(t => {
                if(t) t.split(';').forEach(sub => flatFilter.push(sub.trim()));
          });
          
          p.display_tags = [...new Set(flatDisplay)].filter(Boolean);
          p.filter_tags = [...new Set(flatFilter)].filter(Boolean);
          
          p.quote = p.quote || ""; 
          return p;
      });

    } catch (e) {
      console.error('Error parsing product data:', e);
    }

    this.resultsContainer = this.querySelector('[id^="filter-results-"]');
    this.initEventListeners();
    
    // 2. 检查 URL 参数
    this.checkUrlParams();
  }

  checkUrlParams() {
    const params = new URLSearchParams(window.location.search);
    const filtersParam = params.get('filters');

    if (filtersParam) {
      // --- 现有逻辑：如果有 URL 参数 ---
      const tagsToSelect = filtersParam.split(',').map(tag => decodeURIComponent(tag.trim()));
      const allButtons = this.querySelectorAll('.filter-btn');
      let hasChanges = false;

      allButtons.forEach(btn => {
        const btnValue = btn.dataset.value;
        const groupDiv = btn.closest('.tag-group');
        const groupId = groupDiv.dataset.groupId;

        if (tagsToSelect.includes(btnValue)) {
          // 清除同组其他高亮
          groupDiv.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
          // 激活当前
          btn.classList.add('active');
          this.activeFilters[groupId] = btnValue;
          hasChanges = true;
        }
      });

      if (hasChanges) {
        this.filterAndSortProducts();
      } else {
        // 如果参数有误没匹配到任何按钮，展示默认前6个
        this.renderProducts(this.products.slice(0, 6)); 
      }
    } else {
      const defaultTagsRaw = this.dataset.defaultTags || this.getAttribute('data-default-tags') || '';
      const defaultTags = defaultTagsRaw
        .split(',')
        .map(t => t.trim())
        .filter(Boolean);

      const escapeCssValue = (value) => {
        if (window.CSS && typeof window.CSS.escape === 'function') {
          return window.CSS.escape(value);
        }
        return String(value).replace(/[^a-zA-Z0-9_\u00A0-\uFFFF-]/g, (ch) => `\\${ch}`);
      };

      defaultTags.forEach((defaultTag) => {
        const defaultBtn = this.querySelector(`.filter-btn[data-value="${escapeCssValue(defaultTag)}"]`);

        if (!defaultBtn) return;

        const groupDiv = defaultBtn.closest('.tag-group');
        if (!groupDiv) return;

        const groupId = groupDiv.dataset.groupId;

        // 同组只允许一个选中：清除同组其他
        groupDiv.querySelectorAll('.filter-btn').forEach(b => {
          b.classList.remove('active');
        });

        defaultBtn.classList.add('active');
        this.activeFilters[groupId] = defaultTag;
      });

      // 无论是否匹配到按钮，都走统一的渲染逻辑
      // - 匹配到了：会按默认选中标签进行筛选
      // - 没匹配到/没配置：展示默认结果
      this.filterAndSortProducts();
    }
  }

  initEventListeners() {
    const buttons = this.querySelectorAll('.filter-btn');
    buttons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        this.handleFilterClick(e.currentTarget);
      });
    });
  }

  handleFilterClick(clickedBtn) {
    const groupDiv = clickedBtn.closest('.tag-group');
    const groupId = groupDiv.dataset.groupId;
    const value = clickedBtn.dataset.value;
    const isAlreadyActive = clickedBtn.classList.contains('active');
    
    groupDiv.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));

    if (isAlreadyActive) {
      delete this.activeFilters[groupId];
    } else {
      clickedBtn.classList.add('active');
      this.activeFilters[groupId] = value;
    }

    this.filterAndSortProducts();
  }

  /**
   * 获取组合的辅助函数
   * 逻辑说明：标准的递归回溯。
   * 对于数组 [A, B, C]，取 k=2：
   * 1. 优先取前面的 -> [A, B] (相当于剔除了最后一个 C)
   * 2. 然后取 -> [A, C] (相当于剔除了倒数第二个 B)
   * 3. 最后取 -> [B, C] (相当于剔除了第一个 A)
   * 这个生成顺序完美符合需求中“先剔除最后一个，再剔除倒数第二个”的逻辑。
   */
  getCombinations(arr, k) {
    const results = [];
    function backtrack(start, combo) {
      if (combo.length === k) {
        results.push([...combo]);
        return;
      }
      for (let i = start; i < arr.length; i++) {
        combo.push(arr[i]);
        backtrack(i + 1, combo);
        combo.pop();
      }
    }
    backtrack(0, []);
    return results;
  }

  /**
   * 计算某产品在特定标签组合下的得分（用于同级排序）
   * @param {Object} product - 产品对象
   * @param {Array} tags - 当前匹配的标签数组
   * @returns {Number} - display_tags 命中的数量
   */
  calculateDisplayScore(product, tags) {
    let score = 0;
    tags.forEach(tag => {
      if (product.display_tags.includes(tag)) {
        score++;
      }
    });
    return score;
  }

  /**
   * 核心筛选与排序算法
   * 规则总结：
   * 1. 固定展示 showProductsCount 个结果。
   * 2. 瀑布流筛选：优先匹配 n 个标签 -> n-1 个 -> ... -> 1 个。
   * 3. 同级排序：在命中数相同的情况下，display_tags 命中更多的排前面。
   * 4. 兜底：如果不足，使用有 filter_tags 的任意产品填充。
   */
  filterAndSortProducts() {
    // 一、设置变量
    const showProductsCount = 6; 
    const selectedTags = Object.values(this.activeFilters);
    let finalResults = [];
    let seenProductIds = new Set(); // 用于去重，防止同一个产品被多次添加

    // 二、多标签筛选逻辑 (瀑布流)
    // 仅当用户有勾选标签时执行
    if (selectedTags.length > 0) {
      
      // 循环 k：从匹配所有选中标签 (n) 开始，递减到 1
      // k 代表当前尝试匹配的标签数量
      for (let k = selectedTags.length; k >= 1; k--) {
        
        if (finalResults.length >= showProductsCount) break;

        // 1. 获取选中的 n 个标签中，取 k 个的所有组合
        // 顺序说明：getCombinations 默认顺序即符合“先剔除末尾，再剔除倒数第二...”的要求
        const combinations = this.getCombinations(selectedTags, k);

        // 2. 遍历每一个组合 (例如 [TagA, TagB])
        for (const comboTags of combinations) {
          if (finalResults.length >= showProductsCount) break;

          // 临时数组，用于存放当前这个组合匹配到的候选产品
          let stepCandidates = [];

          // 3. 在产品池中查找匹配当前组合的产品
          for (const product of this.products) {
            if (seenProductIds.has(product.id)) continue; // 已经在结果里了，跳过

            // 严格匹配：产品必须包含当前组合内的所有标签
            // (filter_tags 包含 display 和 hide 的总和)
            const isMatch = comboTags.every(tag => product.filter_tags.includes(tag));

            if (isMatch) {
              stepCandidates.push(product);
            }
          }

          // 4. 同级排序逻辑
          // 此时 stepCandidates 里的所有产品都命中了一样多的标签 (k个)
          // 规则：display_tags 命中数更多的产品排在更前面
          if (stepCandidates.length > 0) {
            stepCandidates.sort((a, b) => {
              const scoreA = this.calculateDisplayScore(a, comboTags);
              const scoreB = this.calculateDisplayScore(b, comboTags);
              return scoreB - scoreA; // 降序排列
            });

            // 5. 将排序后的候选加入最终结果
            for (const candidate of stepCandidates) {
              if (finalResults.length >= showProductsCount) break;
              finalResults.push(candidate);
              seenProductIds.add(candidate.id);
            }
          }
        }
      }
    }

    // 三、兜底/补充逻辑
    // 规则1：若数量不足 showProductsCount，用无关产品凑
    // 规则2：不能用 filter_tags 为空的产品凑
    if (finalResults.length < showProductsCount) {
      for (const product of this.products) {
        if (finalResults.length >= showProductsCount) break;

        // 跳过已存在的产品
        if (seenProductIds.has(product.id)) continue;

        // 检查是否有标签 (防御性编程：确保 filter_tags 存在且长度大于0)
        if (product.filter_tags && product.filter_tags.length > 0) {
          finalResults.push(product);
          seenProductIds.add(product.id);
        }
      }
    }

    // 四、截断 (虽然上面的逻辑已经做了 break，这里再次确保万无一失)
    // 渲染
    this.renderProducts(finalResults);
  }

  renderProducts(productsToRender) {
    if (!productsToRender.length) {
      this.resultsContainer.innerHTML = `<div class="no-results">${this.config.empty_text}</div>`;
      return;
    }

    const html = productsToRender.map((product, index) => {
      let badgeHtml = '';
      if (index === 0 && this.config.top1_icon && this.config.top1_icon.indexOf('no-image') === -1) {
        badgeHtml = `<img src="${this.config.top1_icon}" class="rank-badge" alt="Top 1">`;
      } else if (index === 1 && this.config.top2_icon && this.config.top2_icon.indexOf('no-image') === -1) {
        badgeHtml = `<img src="${this.config.top2_icon}" class="rank-badge" alt="Top 2">`;
      } else if (index === 2 && this.config.top3_icon && this.config.top3_icon.indexOf('no-image') === -1) {
        badgeHtml = `<img src="${this.config.top3_icon}" class="rank-badge" alt="Top 3">`;
      }

      const tagsHtml = product.display_tags.map(tag => 
        `<span class="display-tag">${tag}</span>`
      ).join('');

      const comparePriceHtml = product.compare_price 
        ? `<span class="compare-price">${product.compare_price}</span>` 
        : '';

      const quoteHtml = product.quote 
          ? `<div class="card-quote three-rows">${product.quote}</div>` 
          : '';

      return `
        <a href="${product.url}" class="product-card">
          ${badgeHtml}
          <div class="card-image-wrapper">
            <img src="${product.image}" loading="lazy" class="card-image" alt="${product.title}">
          </div>
          <div class="card-info">
            <div class="card-title-wrapper">
              <h3 class="card-title">${product.title}</h3>
              <div class="card-tags">
                ${tagsHtml}
              </div>
              ${quoteHtml}
            </div>
            <div class="card-price-row">
              <div class="price-wrapper">
                <span class="current-price">${product.price}</span>
                ${comparePriceHtml}
              </div>
              <button class="view-btn">View details ></button>
            </div>
          </div>
        </a>
      `;
    }).join('');

    this.resultsContainer.innerHTML = html;
  }
}

if (!window.customElements.get('product-filter-section')) {
  customElements.define('product-filter-section', ProductFilterSection);
}

class CountdownTimer2 extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.deadlineStr = this.getAttribute('data-deadline');
    this.elements = {
      days: this.querySelector('[data-type="days"]'),
      hours: this.querySelector('[data-type="hours"]'),
      minutes: this.querySelector('[data-type="minutes"]'),
      seconds: this.querySelector('[data-type="seconds"]')
    };

    if (!this.deadlineStr) return;

    this.updateTimer();
    this.timerInterval = setInterval(() => this.updateTimer(), 1000);
  }

  disconnectedCallback() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  updateTimer() {
    // 兼容性处理：将 '-' 替换为 '/' 以支持 Safari
    const formattedDate = this.deadlineStr.replace(/-/g, '/'); 
    const deadline = new Date(formattedDate).getTime();
    const now = new Date().getTime();
    const diff = deadline - now;

    if (diff <= 0) {
      clearInterval(this.timerInterval);
      this.render(0, 0, 0, 0);
      return;
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    this.render(days, hours, minutes, seconds);
  }

  render(d, h, m, s) {
    if(this.elements.days) this.elements.days.textContent = this.pad(d);
    if(this.elements.hours) this.elements.hours.textContent = this.pad(h);
    if(this.elements.minutes) this.elements.minutes.textContent = this.pad(m);
    if(this.elements.seconds) this.elements.seconds.textContent = this.pad(s);
  }

  pad(num) {
    return num < 10 ? '0' + num : num;
  }
}

if (!window.customElements.get('countdown-timer2')) {
  customElements.define('countdown-timer2', CountdownTimer2);
}

/**
 * Class: CouponCopier
 * 功能: 处理点击复制按钮逻辑
 */
class CouponCopier extends HTMLElement {
  constructor() {
    super();
    this.handleCopy = this.handleCopy.bind(this);
  }

  connectedCallback() {
    this.codeToCopy = this.getAttribute('data-code');
    this.button = this.querySelector('button');
    
    if (this.button) {
      // 保存原始按钮文案 (Copy)，以便还原
      this.originalText = this.button.textContent;
      this.button.addEventListener('click', this.handleCopy);
    }
  }

  disconnectedCallback() {
    if (this.button) {
      this.button.removeEventListener('click', this.handleCopy);
    }
  }

  handleCopy() {
    if (!navigator.clipboard || !this.codeToCopy) {
      console.warn('Clipboard API not available or no code provided');
      return;
    }

    navigator.clipboard.writeText(this.codeToCopy)
      .then(() => {
        this.button.textContent = 'Copied';
        
        // 如果有之前的计时器，先清除，防止快速点击导致显示异常
        if (this.revertTimeout) {
          clearTimeout(this.revertTimeout);
        }

        this.revertTimeout = setTimeout(() => {
          this.button.textContent = this.originalText;
        }, 3000);
      })
      .catch(err => {
        console.error('Failed to copy text: ', err);
      });
  }
}

if (!window.customElements.get('coupon-copier')) {
  customElements.define('coupon-copier', CouponCopier);
}

class promoCard extends HTMLElement {
  constructor() {
    super();
    this.btn = this.querySelector('.js-add-to-cart');
    this.variantId = this.dataset.variantId;
    this.originalText = "Add to cart";
    this.isAnimating = false;
    
    if(this.btn) {
      this.btn.addEventListener('click', this.addToCart.bind(this));
    }
  }

  addToCart() {
    if(this.isAnimating || !this.variantId) return;
    this.isAnimating = true;

    // Start Animation
    this.startAnimation();

    // Add to Cart Logic
    let formData = {
      'items': [{
        'id': this.variantId,
        'quantity': 1
      }]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      const event = new CustomEvent("cart:show");
      document.dispatchEvent(event); // 触发事件
      if(!document.body.classList.contains('smart-cart--enabled')) document.dispatchEvent(new CustomEvent("cart:refresh"));
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(() => {
      setTimeout(() => {
        this.stopAnimation();
      }, 3000);
    });
  }

  startAnimation() {
    const span = this.btn.querySelector('.btn-text');
    let dots = 0;
    span.textContent = "Add to cart";
    
    this.animationInterval = setInterval(() => {
      dots = (dots + 1) % 4; 
      let dotStr = "";
      for(let i=0; i<dots; i++) dotStr += ".";
      span.textContent = "Add to cart" + dotStr;
    }, 500); 
  }

  stopAnimation() {
    clearInterval(this.animationInterval);
    const span = this.btn.querySelector('.btn-text');
    span.textContent = this.originalText;
    this.isAnimating = false;
  }
}

if (!window.customElements.get('custom-element-promo-card')) {
  customElements.define('custom-element-promo-card', promoCard);
}

// Feature Accordion 风琴组+图片组件
class FeatureAccordion extends HTMLElement {
  constructor() {
    super();
    this.allowMultiple = this.dataset.allowMultiple === 'true';

    // Elements
    this.items = this.querySelectorAll('.fa-item');
    this.desktopImages = this.querySelectorAll('.fa-desktop-image-item');

    this.init();
  }

  init() {
    this.items.forEach((item, index) => {
      const header = item.querySelector('.fa-item-header');

      // Click Event
      header.addEventListener('click', () => {
        this.toggleItem(index);
      });
    });

    // 从 data-default-open 属性读取默认打开的项目
    this.items.forEach((item, index) => {
      if (item.dataset.defaultOpen === 'true') {
        this.openItem(index);
      }
    });
  }

  toggleItem(index) {
    const item = this.items[index];
    const isOpen = item.classList.contains('open');

    if (!this.allowMultiple) {
      if (isOpen) {
        this.closeItem(index);
      } else {
        this.closeAll();
        this.openItem(index);
      }
    } else {
      if (isOpen) {
        this.closeItem(index);
      } else {
        this.openItem(index);
      }
    }
  }

  openItem(index) {
    if(!this.items[index]) return;

    this.items[index].classList.add('open');

    if(this.desktopImages[index]) {
      this.desktopImages.forEach(img => img.classList.remove('active'));
      this.desktopImages[index].classList.add('active');
    }
  }

  closeItem(index) {
    if(!this.items[index]) return;

    this.items[index].classList.remove('open');

    if(this.desktopImages[index]) {
      this.desktopImages[index].classList.remove('active');
    }
  }

  closeAll() {
    this.items.forEach((el, i) => {
      this.closeItem(i);
    });
  }
}

if (!window.customElements.get('feature-accordion')) {
  customElements.define('feature-accordion', FeatureAccordion);
}

class FloatingBanner extends HTMLElement {
  constructor() {
    super();
    this.handleScroll = this.handleScroll.bind(this);
    this.closeBanner = this.closeBanner.bind(this);
    this.closeBtn = this.querySelector('#StickyBannerClose');
  }

  connectedCallback() {
    window.addEventListener("scroll", this.handleScroll);
    if(this.closeBtn) {
      this.closeBtn.addEventListener("click", (e) => {
        e.preventDefault(); 
        e.stopPropagation(); 
        this.closeBanner();
      });
    }
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  closeBanner() {
    window.removeEventListener("scroll", this.handleScroll);
    this.classList.remove("show");
    // 动画结束后隐藏元素
    setTimeout(() => {
        this.style.display = 'none';
    }, 600);
  }

  handleScroll() {
    const viewportHeight = window.innerHeight;
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;

    // 当滚动超过一屏高度 + 280px 时显示
    if (scrollPosition > viewportHeight + 280) {
      this.classList.add("show");
    } else {
      this.classList.remove("show");
    }
  }
}

if (!window.customElements.get("floating-banner")) {
  customElements.define("floating-banner", FloatingBanner);
}

// 自定义：底部双按钮悬浮Banner（两个按钮锚点跳转 + 关闭）
class FloatingActionBanner extends HTMLElement {
  constructor() {
    super();
    this.handleScroll = this.handleScroll.bind(this);
    this.closeBanner = this.closeBanner.bind(this);
    this.closeBtn = this.querySelector(".fab-close-btn");
  }

  connectedCallback() {
    // 移动到 body，避免受所在分区祖先元素 transform / overflow 影响 fixed 底部悬浮定位
    if (this.parentElement !== document.body) {
      document.body.appendChild(this);
      return; // 重新挂载后会再次触发 connectedCallback，由下方逻辑完成初始化
    }

    window.addEventListener("scroll", this.handleScroll, { passive: true });

    if (this.closeBtn) {
      this.closeBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.closeBanner();
      });
    }

    // 两个按钮的锚点跳转逻辑
    this.querySelectorAll("[data-anchor-target]").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const selector = btn.getAttribute("data-anchor-target");
        if (!selector) return;
        try {
          const target = document.querySelector(selector);
          if (target) {
            target.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        } catch (err) {
          console.warn("floating-action-banner: invalid selector", selector, err);
        }
      });
    });
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  closeBanner() {
    window.removeEventListener("scroll", this.handleScroll);
    this.classList.remove("show");
    // 动画结束后隐藏元素
    setTimeout(() => {
      this.style.display = "none";
    }, 600);
  }

  handleScroll() {
    const viewportHeight = window.innerHeight;
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;

    if (scrollPosition > (viewportHeight - 600)) {
      this.classList.add("show");
    } else {
      this.classList.remove("show");
    }
  }
}

if (!window.customElements.get("floating-action-banner")) {
  customElements.define("floating-action-banner", FloatingActionBanner);
}

// 自定义：Product Comparison Cards 锚点跳转按钮
class PccAnchorButton extends HTMLElement {
  constructor() {
    super()
    this.addEventListener("click", this.handleClick.bind(this))
  }

  handleClick() {
    const selector = this.getAttribute("data-anchor-target")
    if (!selector) return
    const doScroll = () => {
      try {
        const target = document.querySelector(selector)
        if (target) {
          target.scrollIntoView({ behavior: "smooth", block: "start" })
        }
      } catch (err) {
        console.warn("pcc-anchor-btn: invalid selector", selector, err)
      }
    }
    // 若按钮位于探索弹窗内：先关闭弹窗，待动画结束后再滚动到目标
    const modal = this.closest("worry-free-modal, script-trigger-modal")
    if (modal && typeof modal.hide === "function") {
      const hidePromise = modal.hide()
      if (hidePromise && typeof hidePromise.then === "function") {
        hidePromise.then(doScroll)
      } else {
        doScroll()
      }
    } else {
      doScroll()
    }
  }
}

if (!window.customElements.get("pcc-anchor-button")) {
  customElements.define("pcc-anchor-button", PccAnchorButton)
}

// 自定义：Product Comparison Cards Cartsee 表单按钮（与锚点按钮互斥）【短暂使用】
class PccCartSeeButton extends HTMLElement {
  constructor() {
    super()
    this.addEventListener("click", this.handleClick.bind(this))
  }

  handleClick() {
    // 若按钮位于探索弹窗内：先关闭弹窗，再打开 Cartsee 表单
    const modal = this.closest("worry-free-modal, script-trigger-modal")
    if (modal && typeof modal.hide === "function") {
      modal.hide()
    }
    const formId = this.getAttribute("data-form-id")
    if (!formId) return
    window.cartsee = window.cartsee || []
    window.cartsee.push(["openForm", formId])
  }
}

if (!window.customElements.get("pcc-cartsee-button")) {
  customElements.define("pcc-cartsee-button", PccCartSeeButton)
}

// 自定义：Cartsee 悬浮表单按钮（main-product 区块）——滚动方向显隐 + 打开 Cartsee 表单
class CartseeFloatingButton extends HTMLElement {
  constructor() {
    super()
    this.handleScroll = this.handleScroll.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.lastScrollY = 0
    this.scrollToggle = false
  }

  connectedCallback() {
    // 移动到 body，避免受祖先元素 transform / overflow 影响 fixed 定位
    if (this.parentElement !== document.body) {
      document.body.appendChild(this)
      return // 重新挂载后会再次触发 connectedCallback，由下方逻辑完成初始化
    }

    this.scrollToggle = this.getAttribute("data-scroll-toggle") === "true"
    this.button = this.querySelector(".cartsee-floating-btn")
    this.button?.addEventListener("click", this.handleClick)

    if (this.scrollToggle) {
      // 开启滚动显隐：向下滑动显示，向上滑动隐藏
      this.lastScrollY = window.scrollY || window.pageYOffset
      window.addEventListener("scroll", this.handleScroll, { passive: true })
    } else {
      // 未开启滚动显隐：始终显示
      this.classList.add("is-visible")
    }
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.handleScroll)
    this.button?.removeEventListener("click", this.handleClick)
  }

  handleScroll() {
    const currentY = window.scrollY || window.pageYOffset
    if (currentY > this.lastScrollY && currentY > 80) {
      // 向下滑动且离开顶部区域：显示
      this.classList.add("is-visible")
    } else if (currentY < this.lastScrollY) {
      // 向上滑动：隐藏
      this.classList.remove("is-visible")
    }
    this.lastScrollY = currentY
  }

  handleClick() {
    const formId = this.getAttribute("data-form-id")
    if (!formId) return
    window.cartsee = window.cartsee || []
    window.cartsee.push(["openForm", formId])
  }
}

if (!window.customElements.get("cartsee-floating-button")) {
  customElements.define("cartsee-floating-button", CartseeFloatingButton)
}

//自定义：Slideshow锚点跳转按钮
class SlideshowAnchorButton extends HTMLElement {
  constructor() {
    super()
    this.addEventListener("click", this.handleClick.bind(this))
  }

  handleClick() {
    const targetSelector = this.getAttribute("data-target")
    if (!targetSelector) return
    const targetEl = document.querySelector(targetSelector)
    if (targetEl) {
      targetEl.scrollIntoView({ behavior: "smooth", block: "start" })
    }
  }
}

if (!window.customElements.get("slideshow-anchor-button")) {
  customElements.define("slideshow-anchor-button", SlideshowAnchorButton)
}

// 自定义：产品展示卡片 - Add to Cart & Buy Now
class ProductShowcaseCard extends HTMLElement {
  constructor() {
    super();
    this.variantId = this.getAttribute('data-variant-id');
  }

  connectedCallback() {
    this.atcBtn = this.querySelector('[data-psc-atc]');
    this.buyBtn = this.querySelector('[data-psc-buy]');

    if (this.atcBtn) {
      this.atcBtn.addEventListener('click', this.handleAddToCart.bind(this));
    }
    if (this.buyBtn) {
      this.buyBtn.addEventListener('click', this.handleBuyNow.bind(this));
    }
  }

  async handleAddToCart(e) {
    e.preventDefault();
    if (!this.variantId || this.atcBtn.classList.contains('is-loading')) return;

    this.atcBtn.classList.add('is-loading');

    try {
      const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(this.variantId), quantity: 1 }] })
      });
      if (!res.ok) throw new Error('Add to cart failed');
      document.dispatchEvent(new CustomEvent('cart:show'));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (err) {
      console.error('Product Showcase Card ATC error:', err);
    } finally {
      this.atcBtn.classList.remove('is-loading');
    }
  }

  handleBuyNow(e) {
    e.preventDefault();
    if (!this.variantId) return;
    window.location.href = 'https://starpower-sport.myshopify.com/cart/clear?return_to=/cart/add?items[][id]=' + this.variantId + '%26items[][quantity]=1%26return_to=/checkout';
  }
}

if (!window.customElements.get('product-showcase-card')) {
  customElements.define('product-showcase-card', ProductShowcaseCard);
}

// 自定义：Product Match Quiz 多维度加权筛选
class ProductMatchQuiz extends HTMLElement {
  constructor() {
    super();
    this.products = [];
    this.config = {};
    this.activeFilters = {}; // { groupId: { value: string, weight: number } }
  }

  connectedCallback() {
    const sectionEl = this.closest('[id^="shopify-section-"]');
    const sectionId = sectionEl ? sectionEl.id.replace('shopify-section-', '') : '';

    // 解析产品数据和配置
    try {
      const dataScript = this.querySelector(`#pmq-product-data-${sectionId}`);
      const configScript = this.querySelector(`#pmq-config-${sectionId}`);
      if (dataScript) this.products = JSON.parse(dataScript.textContent);
      if (configScript) this.config = JSON.parse(configScript.textContent);

      // 预处理：将元字段值拆分为数组
      this.products = this.products.map(p => {
        const raw = p.filter_values || '';
        p.filter_values = raw.split(';').map(v => v.trim()).filter(Boolean);
        return p;
      });
    } catch (e) {
      console.error('ProductMatchQuiz: Error parsing data', e);
    }

    this.resultsContainer = this.querySelector(`#pmq-results-${sectionId}`);
    this.recommendationContainer = this.querySelector(`#pmq-recommendation-${sectionId}`);

    // 从 DOM 读取 Liquid 渲染的默认选中状态
    this.querySelectorAll('.pmq-btn.active').forEach(btn => {
      const group = btn.closest('.pmq-tag-group');
      if (!group) return;
      const groupId = group.dataset.groupId;
      const weight = parseFloat(group.dataset.weight) || 1;
      this.activeFilters[groupId] = { value: btn.dataset.value, weight };
    });

    this._initEventListeners();
    this._filterProducts();
  }

  _initEventListeners() {
    this.querySelectorAll('.pmq-btn').forEach(btn => {
      btn.addEventListener('click', () => this._handleFilterClick(btn));
    });
  }

  _handleFilterClick(btn) {
    const group = btn.closest('.pmq-tag-group');
    const groupId = group.dataset.groupId;
    const weight = parseFloat(group.dataset.weight) || 1;
    const value = btn.dataset.value;
    const isActive = btn.classList.contains('active');

    // 同组单选：先清除同组所有
    group.querySelectorAll('.pmq-btn').forEach(b => b.classList.remove('active'));

    if (isActive) {
      // 已选中则取消
      delete this.activeFilters[groupId];
    } else {
      btn.classList.add('active');
      this.activeFilters[groupId] = { value, weight };
    }

    this._filterProducts();
  }

  /**
   * 核心筛选算法：最多匹配原则 + 权重
   * 1. 遍历所有产品，根据用户已选维度计算加权得分
   * 2. 按得分从高到低排序
   * 3. 取前 1~3 个结果（优先取 score > 0 的产品，兜底至少展示 1 个）
   */
  _filterProducts() {
    const MAX_RESULTS = 3;
    const selectedEntries = Object.values(this.activeFilters);

    // 无任何筛选条件时：展示前 3 个产品
    if (selectedEntries.length === 0) {
      this._renderProducts(this.products.slice(0, MAX_RESULTS));
      return;
    }

    // 为每个产品计算加权得分
    const scored = this.products.map(product => {
      let score = 0;
      selectedEntries.forEach(entry => {
        if (product.filter_values.includes(entry.value)) {
          score += entry.weight;
        }
      });
      return { product, score };
    });

    // 按得分降序排列；同分则按价格从低到高
    scored.sort((a, b) => {
      if (b.score !== a.score) return b.score - a.score;
      return (a.product.price_raw || 0) - (b.product.price_raw || 0);
    });

    // 优先取 score > 0 的产品，最多 3 个
    let results = scored.filter(s => s.score > 0).slice(0, MAX_RESULTS);

    // 兜底：确保至少展示 1 个产品
    if (results.length === 0 && scored.length > 0) {
      results = scored.slice(0, 1);
    }

    this._renderProducts(results.map(r => r.product));
  }

  _renderProducts(productsToRender) {
    if (!this.resultsContainer) return;

    if (!productsToRender.length) {
      this.resultsContainer.innerHTML = `<div class="pmq-no-results">${this.config.empty_text || 'No matching products found.'}</div>`;
      if (this.recommendationContainer) {
        this.recommendationContainer.textContent = '';
        this.recommendationContainer.style.display = 'none';
      }
      return;
    }

    const cartBtnText = this.config.view_btn_text || 'Add to Cart';

    const html = productsToRender.map(product => {
      const comparePriceHtml = product.compare_price
        ? `<span class="pmq-compare-price">${product.compare_price}</span>`
        : '';

      return `
        <div class="pmq-product-card" data-variant-id="${product.variant_id || ''}">
          <div class="pmq-card-image">
            <a href="${product.url}" class="pmq-card-link">
              <img src="${product.image}" loading="lazy" alt="">
            </a>
          </div>
          <div class="pmq-card-info">
            <a href="${product.url}" class="pmq-card-link">
              <h3 class="pmq-card-title">${product.title}</h3>
            </a>
            <div class="pmq-card-price-row">
              <div class="pmq-price-wrapper">
                <span class="pmq-current-price">${product.price}</span>
                ${comparePriceHtml}
              </div>
              <button type="button" class="pmq-view-btn pmq-add-to-cart">${cartBtnText}</button>
            </div>
          </div>
        </div>
      `;
    }).join('');

    this.resultsContainer.innerHTML = html;

    // 绑定加购按钮事件
    this.resultsContainer.querySelectorAll('.pmq-add-to-cart').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const card = btn.closest('.pmq-product-card');
        const variantId = card?.dataset.variantId;
        if (variantId) this._addToCart(variantId, btn);
      });
    });

    // 展示首个产品的推荐文案
    if (this.recommendationContainer) {
      const topQuote = productsToRender[0]?.quote;
      if (topQuote) {
        this.recommendationContainer.textContent = topQuote;
        this.recommendationContainer.style.display = '';
      } else {
        this.recommendationContainer.textContent = '';
        this.recommendationContainer.style.display = 'none';
      }
    }
  }

  async _addToCart(variantId, btn) {
    const originalHTML = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = `${btn.textContent}<span class="pmq-dots"></span>`;

    // 同时发起请求和 3s 计时
    const timerPromise = new Promise(r => setTimeout(r, 3000));

    try {
      const [res] = await Promise.all([
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        }),
        timerPromise
      ]);

      if (!res.ok) throw new Error('Add to cart failed');

      // 弹出购物车弹框 & 刷新购物车数据
      document.dispatchEvent(new CustomEvent('cart:show'));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (err) {
      console.error('ProductMatchQuiz: Add to cart error', err);
    } finally {
      btn.innerHTML = originalHTML;
      btn.disabled = false;
    }
  }
}

if (!window.customElements.get('product-match-quiz')) {
  customElements.define('product-match-quiz', ProductMatchQuiz);
}

class PressTicker extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.press-ticker__track');
    if (!this.track) return;

    this.allItems = Array.from(this.track.querySelectorAll('.press-ticker__item'));

    this.mqlMobile = window.matchMedia('(max-width: 749px)');
    this._handleMQ = this._applyMode.bind(this);
    this.mqlMobile.addEventListener
      ? this.mqlMobile.addEventListener('change', this._handleMQ)
      : this.mqlMobile.addListener(this._handleMQ);

    this._applyMode();
  }

  disconnectedCallback() {
    this._stopMobileTimer();
    if (this.mqlMobile) {
      this.mqlMobile.removeEventListener
        ? this.mqlMobile.removeEventListener('change', this._handleMQ)
        : this.mqlMobile.removeListener(this._handleMQ);
    }
  }

  _applyMode() {
    if (this.mqlMobile.matches) {
      this._setupMobile();
    } else {
      this._setupDesktop();
    }
  }

  _setupDesktop() {
    this._stopMobileTimer();
    // 显示全部（两份）用于无缝滚动，清掉内联样式残留
    this.allItems.forEach((el) => {
      el.style.display = '';
      this._resetInner(el);
    });
  }

  _setupMobile() {
    this.allItems.forEach((el) => {
      const pass = parseInt(el.dataset.pass || '1', 10);
      el.style.display = pass === 1 ? '' : 'none';
      el.classList.remove('is-selected');
      this._resetInner(el);
    });

    this.mobileItems = this.allItems.filter((el) => parseInt(el.dataset.pass || '1', 10) === 1);
    if (this.mobileItems.length === 0) return;

    this.currentIndex = 0;
    this.mobileItems[0].classList.add('is-selected');

    if (this.mobileItems.length < 2) return;
    if (this.dataset.enableCarousel !== 'true') return;

    const hold = parseFloat(this.dataset.flipHold || '3') * 1000;
    this._mobileTimer = setInterval(() => this._transitionNext(), hold);
  }

  _resetInner(item) {
    const logo = item.querySelector('.press-ticker__logo');
    const quote = item.querySelector('.press-ticker__quote');
    if (logo) {
      logo.style.opacity = '';
      logo.style.transition = '';
    }
    if (quote) {
      quote.style.opacity = '';
      quote.style.transform = '';
      quote.style.transition = '';
    }
  }

  /**
   * 切换：严格参考 press.liquid 中 PressCarousel._transitionTo
   *   1. 先并行淡出旧 slide 的 .press-ticker__logo 与 .press-ticker__quote（quote 伴随 translateY(-10px)）
   *   2. 切换 .is-selected 类
   *   3. 再并行淡入新 slide 的 .press-ticker__logo 与 .press-ticker__quote（quote 从 translateY(10px) 回到 0）
   */
  async _transitionNext() {
    const items = this.mobileItems;
    if (!items || items.length < 2) return;

    const fromItem = items[this.currentIndex];
    const nextIndex = (this.currentIndex + 1) % items.length;
    const toItem = items[nextIndex];

    const duration = 200; // 对齐 press.js 的 0.2s

    await this._animateOut(fromItem, duration);

    fromItem.classList.remove('is-selected');
    toItem.classList.add('is-selected');

    // 切换后把旧 slide 的内联样式重置，避免下次进入时状态残留
    this._resetInner(fromItem);

    await this._animateIn(toItem, duration);

    this.currentIndex = nextIndex;
  }

  _animateOut(item, duration) {
    return new Promise((resolve) => {
      const logo = item.querySelector('.press-ticker__logo');
      const quote = item.querySelector('.press-ticker__quote');

      if (logo) {
        logo.style.transition = 'opacity ' + duration + 'ms ease';
        logo.style.opacity = '0';
      }
      if (quote) {
        quote.style.transition = 'opacity ' + duration + 'ms ease, transform ' + duration + 'ms ease';
        quote.style.opacity = '0';
        quote.style.transform = 'translateY(-10px)';
      }

      setTimeout(resolve, duration);
    });
  }

  _animateIn(item, duration) {
    return new Promise((resolve) => {
      const logo = item.querySelector('.press-ticker__logo');
      const quote = item.querySelector('.press-ticker__quote');

      // 起始态（无过渡）
      if (logo) {
        logo.style.transition = 'none';
        logo.style.opacity = '0';
      }
      if (quote) {
        quote.style.transition = 'none';
        quote.style.opacity = '0';
        quote.style.transform = 'translateY(10px)';
      }

      // 下一帧开启过渡到终态
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (logo) {
            logo.style.transition = 'opacity ' + duration + 'ms ease';
            logo.style.opacity = '1';
          }
          if (quote) {
            quote.style.transition = 'opacity ' + duration + 'ms ease, transform ' + duration + 'ms ease';
            quote.style.opacity = '1';
            quote.style.transform = 'translateY(0)';
          }
          setTimeout(resolve, duration);
        });
      });
    });
  }

  _stopMobileTimer() {
    if (this._mobileTimer) {
      clearInterval(this._mobileTimer);
      this._mobileTimer = null;
    }
  }
}
if (!window.customElements.get('press-ticker')) {
  customElements.define('press-ticker', PressTicker);
}

// 自定义：Shop By Category - PC 3列网格 + H5 Swiper+Tab 联动
class ShopByCategory extends HTMLElement {
  constructor() {
    super();
    this._mqMobile = window.matchMedia('(max-width: 767px)');
    this._swiper = null;
    this._resizeHandler = null;
    this._onTabClick = this._onTabClick.bind(this);
    this._onMqChange = this._onMqChange.bind(this);
  }

  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('.sbc__tab'));
    this.indicator = this.querySelector('.sbc__tab-indicator');
    this.swiperEl = this.querySelector('.sbc__swiper');

    // 绑定 tab 点击事件
    this.tabs.forEach((tab) => tab.addEventListener('click', this._onTabClick));

    if (this._mqMobile.matches) {
      this._initMobile();
    }

    // 监听视口变化
    if (typeof this._mqMobile.addEventListener === 'function') {
      this._mqMobile.addEventListener('change', this._onMqChange);
    } else if (typeof this._mqMobile.addListener === 'function') {
      this._mqMobile.addListener(this._onMqChange);
    }
  }

  disconnectedCallback() {
    this.tabs?.forEach((tab) => tab.removeEventListener('click', this._onTabClick));
    this._destroyMobile();
    if (typeof this._mqMobile.removeEventListener === 'function') {
      this._mqMobile.removeEventListener('change', this._onMqChange);
    } else if (typeof this._mqMobile.removeListener === 'function') {
      this._mqMobile.removeListener(this._onMqChange);
    }
  }

  _onMqChange(e) {
    if (e.matches) {
      this._initMobile();
    } else {
      this._destroyMobile();
    }
  }

  _initMobile() {
    if (this._swiper || !this.swiperEl || typeof Swiper === 'undefined') return;

    const slidesPerView = parseFloat(this.getAttribute('h5-show-num')) || 1.15;
    const spaceBetween = parseInt(this.getAttribute('h5-picture-gap'), 10) || 10;

    this._swiper = new Swiper(this.swiperEl, {
      slidesPerView: slidesPerView,
      spaceBetween: spaceBetween,
      grabCursor: true,
      watchSlidesProgress: true,
      on: {
        slideChange: () => this._setActiveTab(this._swiper.activeIndex),
        init: () => this._updateIndicator(),
      },
    });

    // 初始激活第一个 tab 并渲染指示条
    this._setActiveTab(0);

    // 监听窗口 resize 以刷新指示条位置
    this._resizeHandler = () => this._updateIndicator();
    window.addEventListener('resize', this._resizeHandler);

    // 图片加载完成后再校准一次
    const imgs = this.querySelectorAll('.sbc__img');
    imgs.forEach((img) => {
      if (!img.complete) {
        img.addEventListener('load', this._resizeHandler, { once: true });
      }
    });
  }

  _destroyMobile() {
    if (this._swiper) {
      try { this._swiper.destroy(true, true); } catch (e) { /* noop */ }
      this._swiper = null;
    }
    if (this._resizeHandler) {
      window.removeEventListener('resize', this._resizeHandler);
      this._resizeHandler = null;
    }
    // PC 下隐藏指示条宽度即可
    if (this.indicator) {
      this.indicator.style.width = '0px';
    }
  }

  _onTabClick(event) {
    const btn = event.currentTarget;
    const index = parseInt(btn.getAttribute('data-index'), 10) || 0;
    if (this._swiper) {
      this._swiper.slideTo(index);
    }
    this._setActiveTab(index);
  }

  _setActiveTab(index) {
    if (!this.tabs || this.tabs.length === 0) return;
    if (index < 0 || index >= this.tabs.length) return;
    this.tabs.forEach((tab, i) => {
      const active = i === index;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    this._updateIndicator();
  }

  _updateIndicator() {
    if (!this.indicator || !this.tabs || this.tabs.length === 0) return;
    const activeTab = this.tabs.find((t) => t.classList.contains('is-active')) || this.tabs[0];
    if (!activeTab) return;
    const tabsRect = activeTab.parentElement.getBoundingClientRect();
    const rect = activeTab.getBoundingClientRect();
    const left = rect.left - tabsRect.left;
    this.indicator.style.width = rect.width + 'px';
    this.indicator.style.transform = `translateX(${left}px)`;
  }
}

if (!window.customElements.get('shop-by-category')) {
  customElements.define('shop-by-category', ShopByCategory);
}

// 自定义：Shop the look paginated
// PC: 翻页 + 激活；H5: 横滑 + 激活
class ShopTheLookPaginated extends HTMLElement {
  constructor() {
    super();
    this._currentPage = 0;
    this._activeTimer = null;
  }

  connectedCallback() {
    this._perPage = parseInt(this.dataset.perPage, 10) || 3;
    this._total = parseInt(this.dataset.total, 10) || 0;
    this._totalPages = Math.max(1, Math.ceil(this._total / this._perPage));

    this._track = this.querySelector('[data-stlp-track]');
    this._prevBtn = this.querySelector('[data-stlp-prev]');
    this._nextBtn = this.querySelector('[data-stlp-next]');
    this._scroll = this.querySelector('[data-stlp-scroll]');
    this._dots = Array.from(this.querySelectorAll('[data-stlp-dot]'));
    this._mobileItems = Array.from(this.querySelectorAll('[data-stlp-mobile-item]'));

    if (this._prevBtn) {
      this._prevBtn.addEventListener('click', () => this.goToPage(this._currentPage - 1));
    }
    if (this._nextBtn) {
      this._nextBtn.addEventListener('click', () => this.goToPage(this._currentPage + 1));
    }

    this._dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const idx = parseInt(dot.dataset.index, 10) || 0;
        this.activateIndex(idx);
      });
    });

    this.goToPage(0);
  }

  goToPage(page) {
    if (!this._track) return;
    const clamped = Math.min(Math.max(0, page), this._totalPages - 1);
    this._currentPage = clamped;
    this._track.style.transform = `translateX(-${clamped * 100}%)`;
    if (this._prevBtn) this._prevBtn.disabled = clamped <= 0;
    if (this._nextBtn) this._nextBtn.disabled = clamped >= this._totalPages - 1;
  }

  activateIndex(index) {
    // 更新 dot 状态
    this._dots.forEach((d) => {
      d.setAttribute('aria-current', String(parseInt(d.dataset.index, 10) === index));
    });

    const isDesktop = window.matchMedia('(min-width: 750px)').matches;

    if (isDesktop) {
      const targetPage = Math.floor(index / this._perPage);
      this.goToPage(targetPage);
      // 激活效果延迟一点，等翻页动画完成
      setTimeout(() => this._highlightCard(index), 200);
    } else {
      // H5：滚动到对应 item 的最左（不做激活高亮）
      const target = this._mobileItems.find(
        (it) => parseInt(it.dataset.index, 10) === index
      );
      if (target && this._scroll) {
        const left = target.offsetLeft - this._scroll.offsetLeft;
        this._scroll.scrollTo({ left, behavior: 'smooth' });
      }
    }
  }

  _highlightCard(index) {
    if (this._activeTimer) {
      clearTimeout(this._activeTimer);
    }
    this.querySelectorAll('.stlp-card.is-active').forEach((c) => c.classList.remove('is-active'));

    // 仅对 PC 端的卡片做激活（H5 端不需要）
    const cards = this.querySelectorAll(`.stlp__pc .stlp-card[data-index="${index}"]`);
    cards.forEach((c) => c.classList.add('is-active'));

    this._activeTimer = setTimeout(() => {
      cards.forEach((c) => c.classList.remove('is-active'));
    }, 1800);
  }
}

if (!window.customElements.get('shop-the-look-paginated')) {
  customElements.define('shop-the-look-paginated', ShopTheLookPaginated);
}



/* ============================================================
   Inline Mobile Menu Controller
   参考 merach 项目的内嵌式移动端菜单实现
   - 将 navigation-drawer 由弹窗改为内嵌渲染
   - 同步切换按钮 (.menu-switch-button) 的 .opened 状态（汉堡 <-> X）
   - 移动端点击外部关闭
   ============================================================ */
class InlineMenuController extends HTMLElement {
  constructor() {
    super();
    this._handleOutsideClick = this._handleOutsideClick.bind(this);
  }
  connectedCallback() {
    this._tryInit();
  }
  disconnectedCallback() {
    document.removeEventListener('click', this._handleOutsideClick, true);
  }
  _tryInit(retry = 0) {
    const drawer = this.querySelector('navigation-drawer');
    const targetId = this.getAttribute('target') || (drawer && drawer.id);
    const button = targetId ? document.querySelector(`[aria-controls="${targetId}"]`) : null;
    if (!drawer || !button) {
      if (retry < 20) {
        setTimeout(() => this._tryInit(retry + 1), 50);
      }
      return;
    }
    this.drawer = drawer;
    this.button = button;
    // override shouldAppendToBody (keep drawer inline)
    try {
      Object.defineProperty(drawer, 'shouldAppendToBody', {
        get: () => false,
        configurable: true,
      });
    } catch (e) {
      /* ignore */
    }
    // Skip default clip-path / opacity transitions on mobile to avoid blank delay
    const originalShow = drawer._showTransition && drawer._showTransition.bind(drawer);
    const originalHide = drawer._hideTransition && drawer._hideTransition.bind(drawer);
    const isMobile = () => !window.matchMedia('(min-width: 1150px)').matches;
    drawer._showTransition = function (animate) {
      if (isMobile()) {
        this.style.opacity = '1';
        this.style.visibility = 'visible';
        const content = this.shadowRoot && this.shadowRoot.querySelector('[part="content"]');
        if (content) {
          content.style.clipPath = 'none';
          content.style.opacity = '1';
          Array.from(content.children).forEach((c) => {
            c.style.opacity = '1';
          });
        }
        this.classList.add('show-close-cursor');
        return { finished: Promise.resolve() };
      }
      return originalShow ? originalShow(animate) : { finished: Promise.resolve() };
    };
    drawer._hideTransition = function () {
      if (isMobile()) {
        this.style.opacity = '0';
        this.style.visibility = 'hidden';
        this.classList.remove('show-close-cursor');
        return { finished: Promise.resolve() };
      }
      return originalHide ? originalHide() : { finished: Promise.resolve() };
    };
    // sync button opened state
    drawer.addEventListener('dialog:after-show', (e) => {
      if (e.target !== drawer) return;
      button.classList.add('opened');
    });
    drawer.addEventListener('dialog:after-hide', (e) => {
      if (e.target !== drawer) return;
      button.classList.remove('opened');
    });
    // 兜底：drawer open 属性变化（有些动画路径可能错过 after-* 事件）
    const obs = new MutationObserver(() => {
      if (drawer.hasAttribute('open')) {
        button.classList.add('opened');
      } else {
        button.classList.remove('opened');
      }
    });
    obs.observe(drawer, { attributes: true, attributeFilter: ['open'] });
    // 点击外部关闭（仅移动端内嵌模式）
    document.addEventListener('click', this._handleOutsideClick, true);
  }
  _handleOutsideClick(event) {
    if (!this.drawer || !this.button) return;
    if (!this.drawer.hasAttribute('open')) return;
    // 仅在移动端（菜单按钮可见时）处理
    if (window.matchMedia('(min-width: 1150px)').matches) return;
    const target = event.target;
    if (this.contains(target)) return;
    if (this.button.contains(target)) return;
    // 忽略弹层（如国家/语言切换的 popover、其他 dialog）内的点击，
    // 这些组件通常被 portal 到 body 之下，不在 drawer DOM 内，但属于 drawer 内触发的交互。
    if (target.closest && target.closest('x-popover, .popover, dialog-element, [role="dialog"]')) return;
    if (typeof this.drawer.hide === 'function') {
      this.drawer.hide();
    }
  }
}
if (!window.customElements.get('inline-menu-controller')) {
  customElements.define('inline-menu-controller', InlineMenuController);
}


/* ============================================================
   Ship-Date Protection 发货日期保护条
   - 从 .ship-date-protection-data 读取当前商品变体价格与保费梯度
   - 按当前选中变体售价 * 1% 向上取目标保费变体
   - 勾选后随产品表单 Add to cart 一起加购；取消勾选时移除已在购物车中的保费变体
   ============================================================ */
class ShipDateProtection extends HTMLElement {
  constructor() {
    super();
    this._onToggleClick = this._onToggleClick.bind(this);
    this._onToggleKeydown = this._onToggleKeydown.bind(this);
    this._onCheckboxChange = this._onCheckboxChange.bind(this);
    this._onVariantChange = this._onVariantChange.bind(this);
    this._onCartEvent = this._onCartEvent.bind(this);
    this._isUpdating = false;
  }

  connectedCallback() {
    this.formId = this.dataset.formId;
    this.productId = Number(this.dataset.productId) || 0;
    this.currencyCode = this.dataset.currencyCode || 'USD';
    this.checkbox = this.querySelector('[data-sdp-checkbox]');
    this.priceEl = this.querySelector('[data-sdp-price]');
    this.toggleEl = this.querySelector('[data-sdp-toggle]');
    this.form = this.formId ? document.forms[this.formId] : null;

    const data = this._readData();
    this.productVariants = data.productVariants;
    this.premiumVariants = data.premiumVariants;
    this.cartVariantIds = new Set(data.cartVariantIds);
    this.premiumVariantIds = new Set(this.premiumVariants.map((variant) => variant.id));

    if (this.toggleEl) {
      this.toggleEl.addEventListener('click', this._onToggleClick);
      this.toggleEl.addEventListener('keydown', this._onToggleKeydown);
    }
    if (this.checkbox) {
      this.checkbox.addEventListener('change', this._onCheckboxChange);
    }
    if (this.form) {
      this.form.addEventListener('variant:change', this._onVariantChange);
    }

    document.addEventListener('cart:change', this._onCartEvent);
    document.addEventListener('cart:refresh', this._onCartEvent);

    const selectedVariantId = Number(this.dataset.selectedVariantId) || Number(this.form?.id?.value) || 0;
    this._updateTargetByVariantId(selectedVariantId);
    this._syncCheckedFromCart();
  }

  disconnectedCallback() {
    if (this.toggleEl) {
      this.toggleEl.removeEventListener('click', this._onToggleClick);
      this.toggleEl.removeEventListener('keydown', this._onToggleKeydown);
    }
    if (this.checkbox) {
      this.checkbox.removeEventListener('change', this._onCheckboxChange);
    }
    if (this.form) {
      this.form.removeEventListener('variant:change', this._onVariantChange);
    }
    document.removeEventListener('cart:change', this._onCartEvent);
    document.removeEventListener('cart:refresh', this._onCartEvent);
  }

  getCartAddVariantId() {
    if (!this.checkbox?.checked || !this.targetVariantId) return null;
    if (this.cartVariantIds.has(this.targetVariantId)) return null;
    return this.targetVariantId;
  }

  _readData() {
    const dataEl = this.querySelector('.ship-date-protection-data');
    let data = {};
    if (dataEl) {
      try {
        data = JSON.parse(dataEl.textContent || '{}');
      } catch (err) {
        console.warn('[ShipDateProtection] 数据池解析失败:', err);
      }
    }

    return {
      productVariants: (Array.isArray(data.productVariants) ? data.productVariants : [])
        .filter((variant) => variant && variant.id && typeof variant.price === 'number'),
      premiumVariants: (Array.isArray(data.premiumVariants) ? data.premiumVariants : [])
        .filter((variant) => variant && variant.id && typeof variant.price === 'number')
        .sort((a, b) => a.price - b.price),
      cartVariantIds: (Array.isArray(data.cartVariantIds) ? data.cartVariantIds : [])
        .map((id) => Number(id))
        .filter(Boolean),
    };
  }

  _findTargetVariant(productPriceCents) {
    if (!this.premiumVariants.length) return null;
    const targetCents = productPriceCents * 0.01;
    for (let i = 0; i < this.premiumVariants.length; i++) {
      if (this.premiumVariants[i].price >= targetCents) return this.premiumVariants[i];
    }
    return this.premiumVariants[this.premiumVariants.length - 1];
  }

  _updateTargetByVariantId(variantId) {
    const productVariant = this.productVariants.find((variant) => variant.id === Number(variantId));
    const target = productVariant ? this._findTargetVariant(productVariant.price) : null;
    this.targetVariantId = target?.id || 0;
    this.dataset.targetVariantId = this.targetVariantId ? String(this.targetVariantId) : '';
    this.dataset.sdpSelected = this.checkbox?.checked ? 'true' : 'false';

    if (target && this.priceEl) {
      this.priceEl.textContent = this._formatPrice(target.price);
    }
  }

  _formatPrice(cents) {
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || this.currencyCode;
    try {
      return `+${new Intl.NumberFormat(Shopify.locale || 'en-US', { style: 'currency', currency }).format(cents / 100)}`;
    } catch (err) {
      return `+$${(cents / 100).toFixed(2)}`;
    }
  }

  _setChecked(checked) {
    if (!this.checkbox) return;
    this.checkbox.checked = checked;
    this.dataset.sdpSelected = checked ? 'true' : 'false';
  }

  _syncCheckedFromCart() {
    this._setChecked(Boolean(this.targetVariantId && this.cartVariantIds.has(this.targetVariantId)));
  }

  _onToggleClick(event) {
    if (event.target.closest('a')) return;
    if (event.target === this.checkbox) return;
    this._toggleCheckbox();
  }

  _onToggleKeydown(event) {
    if (event.target.closest('a') || event.target === this.checkbox) return;
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    this._toggleCheckbox();
  }

  _toggleCheckbox() {
    if (!this.checkbox || this.checkbox.disabled) return;
    this.checkbox.checked = !this.checkbox.checked;
    this.checkbox.dispatchEvent(new Event('change', { bubbles: true }));
  }

  _onCheckboxChange() {
    this.dataset.sdpSelected = this.checkbox?.checked ? 'true' : 'false';
    if (!this.checkbox?.checked) {
      this._removeFromCart();
    }
  }

  _onVariantChange(event) {
    const variantId = event.detail?.variant?.id || this.form?.id?.value;
    this._updateTargetByVariantId(variantId);
    if (this.cartVariantIds.size) {
      this._syncCheckedFromCart();
    }
  }

  async _onCartEvent(event) {
    if (this._isUpdating) return;
    try {
      const cart = event.detail?.cart || await this._fetchCart();
      this.cartVariantIds = new Set();
      (cart.items || []).forEach((item) => {
        if (item.product_id === this.productId || this.premiumVariantIds.has(item.variant_id)) {
          this.cartVariantIds.add(item.variant_id);
        }
      });
      this._syncCheckedFromCart();
    } catch (err) {
      console.warn('[ShipDateProtection] 购物车同步失败:', err);
    }
  }

  async _fetchCart() {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const res = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    return res.json();
  }

  async _removeFromCart() {
    if (this._isUpdating || !this.targetVariantId || !this.cartVariantIds.has(this.targetVariantId)) return;
    this._isUpdating = true;
    if (this.checkbox) this.checkbox.disabled = true;

    const updates = {
      [this.targetVariantId]: 0,
    };

    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ updates }),
      });
      this.cartVariantIds.delete(this.targetVariantId);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (err) {
      console.error('[ShipDateProtection] 移除购物车保费失败:', err);
    } finally {
      this._isUpdating = false;
      if (this.checkbox) this.checkbox.disabled = false;
    }
  }
}

if (!window.customElements.get('ship-date-protection')) {
  customElements.define('ship-date-protection', ShipDateProtection);
}


/* ============================================================
   Guarantee Service List 保障服务集合
   - 多个服务复用同一数据结构与交互
   - 按当前选中变体售价 * 各服务配置费率 向上取目标保费变体
   - 勾选/取消时直接同步购物车，并监听购物车变化回填 checkbox
   ============================================================ */
class GuaranteeServiceList extends HTMLElement {
  constructor() {
    super();
    this._onVariantChange = this._onVariantChange.bind(this);
    this._onCartEvent = this._onCartEvent.bind(this);
    this._onExpandClick = this._onExpandClick.bind(this);
    this._onDetailsClick = this._onDetailsClick.bind(this);
    this._onCheckboxChange = this._onCheckboxChange.bind(this);
    this._isSyncingFromCart = false;
  }

  connectedCallback() {
    this.formId = this.dataset.formId;
    this.form = this.formId ? document.forms[this.formId] : null;
    this.currencyCode = this.dataset.currencyCode || 'USD';

    const data = this._readData();
    this.productVariants = data.productVariants;
    this.services = data.services.map((service) => this._createServiceState(service)).filter(Boolean);

    this.services.forEach((service) => {
      service.expandButton?.addEventListener('click', this._onExpandClick);
      service.summaryEl?.addEventListener('click', this._onDetailsClick);
      service.detailsEl?.addEventListener('click', this._onDetailsClick);
      service.checkbox?.addEventListener('change', this._onCheckboxChange);
    });

    if (this.form) {
      this.form.addEventListener('variant:change', this._onVariantChange);
    }
    document.addEventListener('cart:change', this._onCartEvent);
    document.addEventListener('cart:refresh', this._onCartEvent);

    const selectedVariantId = Number(this.dataset.selectedVariantId) || Number(this.form?.id?.value) || 0;
    this._updateTargetsByVariantId(selectedVariantId);
    this._syncAllCheckedFromCart();
  }

  disconnectedCallback() {
    this.services?.forEach((service) => {
      service.expandButton?.removeEventListener('click', this._onExpandClick);
      service.summaryEl?.removeEventListener('click', this._onDetailsClick);
      service.detailsEl?.removeEventListener('click', this._onDetailsClick);
      service.checkbox?.removeEventListener('change', this._onCheckboxChange);
    });
    if (this.form) {
      this.form.removeEventListener('variant:change', this._onVariantChange);
    }
    document.removeEventListener('cart:change', this._onCartEvent);
    document.removeEventListener('cart:refresh', this._onCartEvent);
  }

  _readData() {
    const dataEl = this.querySelector('.guarantee-service-list-data');
    let data = {};
    if (dataEl) {
      try {
        data = JSON.parse(dataEl.textContent || '{}');
      } catch (err) {
        console.warn('[GuaranteeServiceList] 数据池解析失败:', err);
      }
    }

    return {
      productVariants: (Array.isArray(data.productVariants) ? data.productVariants : [])
        .filter((variant) => variant && variant.id && typeof variant.price === 'number'),
      services: Array.isArray(data.services) ? data.services : [],
    };
  }

  _createServiceState(service) {
    if (!service?.key) return null;
    const el = this.querySelector(`[data-gsl-service][data-service-key="${service.key}"]`);
    if (!el) return null;
    const variants = (Array.isArray(service.variants) ? service.variants : [])
      .filter((variant) => variant && variant.id && typeof variant.price === 'number')
      .sort((a, b) => a.price - b.price);

    return {
      key: service.key,
      productId: Number(service.productId) || 0,
      premiumRate: Math.max(Number(service.premiumRate) || 1, 0) / 100,
      el,
      checkbox: el.querySelector('[data-gsl-checkbox]'),
      summaryEl: el.querySelector('.guarantee-service-list__summary'),
      priceEl: el.querySelector('[data-gsl-price]'),
      expandButton: el.querySelector('[data-gsl-expand]'),
      detailsEl: el.querySelector('[data-gsl-details]'),
      variants,
      variantIds: new Set(variants.map((variant) => variant.id)),
      cartVariantIds: new Set((Array.isArray(service.cartVariantIds) ? service.cartVariantIds : []).map((id) => Number(id)).filter(Boolean)),
      targetVariantId: 0,
      isUpdating: false,
    };
  }

  _findTargetVariant(service, productPriceCents) {
    if (!service.variants.length) return null;
    const targetCents = productPriceCents * service.premiumRate;
    for (let i = 0; i < service.variants.length; i++) {
      if (service.variants[i].price >= targetCents) return service.variants[i];
    }
    return service.variants[service.variants.length - 1];
  }

  _updateTargetsByVariantId(variantId) {
    const productVariant = this.productVariants.find((variant) => variant.id === Number(variantId));
    this.services.forEach((service) => {
      const target = productVariant ? this._findTargetVariant(service, productVariant.price) : null;
      service.targetVariantId = target?.id || 0;
      service.el.dataset.targetVariantId = service.targetVariantId ? String(service.targetVariantId) : '';
      if (target && service.priceEl) {
        service.priceEl.textContent = this._formatPrice(target.price);
      }
    });
  }

  _formatPrice(cents) {
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || this.currencyCode;
    try {
      return `+${new Intl.NumberFormat(Shopify.locale || 'en-US', { style: 'currency', currency }).format(cents / 100)}`;
    } catch (err) {
      return `+$${(cents / 100).toFixed(2)}`;
    }
  }

  _setServiceChecked(service, checked) {
    if (!service.checkbox) return;
    service.checkbox.checked = checked;
    service.el.dataset.gslSelected = checked ? 'true' : 'false';
  }

  _syncServiceCheckedFromCart(service) {
    const checked = Boolean(service.targetVariantId && service.cartVariantIds.has(service.targetVariantId));
    this._setServiceChecked(service, checked);
  }

  _syncAllCheckedFromCart() {
    this._isSyncingFromCart = true;
    this.services.forEach((service) => this._syncServiceCheckedFromCart(service));
    this._isSyncingFromCart = false;
  }

  _onVariantChange(event) {
    const variantId = event.detail?.variant?.id || this.form?.id?.value;
    this._updateTargetsByVariantId(variantId);
    this._syncAllCheckedFromCart();
  }

  async _onCartEvent(event) {
    if (this.services.some((service) => service.isUpdating)) return;
    try {
      const cart = event.detail?.cart || await this._fetchCart();
      this.services.forEach((service) => {
        service.cartVariantIds = new Set();
      });
      (cart.items || []).forEach((item) => {
        this.services.forEach((service) => {
          if (item.product_id === service.productId || service.variantIds.has(item.variant_id)) {
            service.cartVariantIds.add(item.variant_id);
          }
        });
      });
      this._syncAllCheckedFromCart();
    } catch (err) {
      console.warn('[GuaranteeServiceList] 购物车同步失败:', err);
    }
  }

  async _fetchCart() {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const res = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    return res.json();
  }

  _onExpandClick(event) {
    const service = this._getServiceFromTarget(event.currentTarget);
    if (!service) return;
    const isOpen = !service.el.classList.contains('is-open');
    this._setServiceOpen(service, isOpen);
  }

  _setServiceOpen(service, isOpen) {
    service.el.classList.toggle('is-open', isOpen);
    if (service.detailsEl) service.detailsEl.hidden = !isOpen;
    service.expandButton?.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  _onDetailsClick(event) {
    if (event.target.closest('a') || event.target.closest('[data-gsl-expand]') || event.target.closest('[data-gsl-checkbox]')) return;
    const service = this._getServiceFromTarget(event.currentTarget);
    if (!service) return;
    this._toggleServiceCheckbox(service);
  }

  _toggleServiceCheckbox(service) {
    if (!service.checkbox || service.checkbox.disabled) return;
    service.checkbox.checked = !service.checkbox.checked;
    service.checkbox.dispatchEvent(new Event('change', { bubbles: true }));
  }

  _onCheckboxChange(event) {
    if (this._isSyncingFromCart) return;
    const service = this._getServiceFromTarget(event.currentTarget);
    if (!service || service.isUpdating || !service.targetVariantId) {
      if (service) this._syncServiceCheckedFromCart(service);
      return;
    }
    this._updateServiceCart(service, event.currentTarget.checked);
  }

  async _updateServiceCart(service, shouldAdd) {
    const previousChecked = Boolean(service.targetVariantId && service.cartVariantIds.has(service.targetVariantId));
    service.isUpdating = true;
    if (service.checkbox) {
      service.checkbox.disabled = true;
      service.checkbox.checked = previousChecked;
    }

    try {
      if (shouldAdd) {
        await this._addServiceToCart(service);
        service.cartVariantIds = new Set([service.targetVariantId]);
      } else {
        await this._removeServiceFromCart(service);
        service.cartVariantIds = new Set();
      }
      this._setServiceChecked(service, shouldAdd);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (err) {
      console.error('[GuaranteeServiceList] 更新保障服务失败:', err);
      this._setServiceChecked(service, previousChecked);
    } finally {
      service.isUpdating = false;
      if (service.checkbox) service.checkbox.disabled = false;
    }
  }

  async _addServiceToCart(service) {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const res = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ items: [{ id: service.targetVariantId, quantity: 1 }] }),
    });
    if (!res.ok) throw new Error('Add guarantee service failed');
  }

  async _removeServiceFromCart(service) {
    const cart = await this._fetchCart();
    const updates = {};
    (cart.items || []).forEach((item) => {
      if (item.variant_id === service.targetVariantId) {
        updates[item.key || item.variant_id] = 0;
      }
    });

    if (!Object.keys(updates).length) return;

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const res = await fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ updates }),
    });
    if (!res.ok) throw new Error('Remove guarantee service failed');
  }

  _getServiceFromTarget(target) {
    const serviceEl = target?.closest?.('[data-gsl-service]');
    if (!serviceEl) return null;
    return this.services.find((service) => service.el === serviceEl) || null;
  }
}

if (!window.customElements.get('guarantee-service-list')) {
  customElements.define('guarantee-service-list', GuaranteeServiceList);
}

/* ============================================================
   Worry-Free Delivery 邮包险
   - 从 .worry-free-data-pool 读取变体梯度数据
   - 监听 cart:change / cart:refresh，按 总价*2.5% 向上取目标变体
   - 自动替换购物车中已存在的"旧档"变体为新的目标变体
   - 与购物车状态双向同步（勾选 / 取消勾选）
   ============================================================ */
class WorryFreeDelivery extends HTMLElement {
  constructor() {
    super();
    this._onChange = this._onChange.bind(this);
    this._onCartEvent = this._onCartEvent.bind(this);
    this._onHelpClick = this._onHelpClick.bind(this);
    this._onModalAction = this._onModalAction.bind(this);
    this._isUpdating = false;
  }

  connectedCallback() {
    this.productId = Number(this.dataset.productId) || 0;
    this.currencyCode = this.dataset.currencyCode || 'USD';

    // 解析数据池
    const poolEl = this.querySelector('.worry-free-data-pool');
    let variants = [];
    if (poolEl) {
      try {
        const data = JSON.parse(poolEl.textContent || '{}');
        variants = Array.isArray(data.variants) ? data.variants : [];
      } catch (e) {
        console.warn('[WorryFreeDelivery] 数据池解析失败:', e);
      }
    }
    // 按价格升序排序（price 单位:分）
    this.variants = variants
      .filter((v) => v && typeof v.price === 'number' && v.id)
      .sort((a, b) => a.price - b.price);

    this.checkbox = this.querySelector('[data-wf-checkbox]');
    this.priceEl = this.querySelector('[data-wf-price]');
    this.helpBtn = this.querySelector('.worry-free-delivery__help');

    if (this.helpBtn) {
      this.helpBtn.addEventListener('click', this._onHelpClick);
    }

    // 为模态框的动作按钮绑定事件（全局单例，只绑一次）
    const modal = document.querySelector('worry-free-modal');
    if (modal && !modal.__wfActionsBound) {
      modal.__wfActionsBound = true;
      modal.addEventListener('click', this._onModalAction);
    }

    if (this.checkbox) {
      this.checkbox.addEventListener('change', this._onChange);
    }

    // 监听全局购物车事件
    document.addEventListener('cart:change', this._onCartEvent);
    document.addEventListener('cart:refresh', this._onCartEvent);

    // 初次同步：使用 liquid 注入的 data-base-total
    const baseTotal = Number(this.dataset.baseTotal) || 0;
    const inCartVariantId = Number(this.dataset.inCartVariantId) || 0;
    this._sync(baseTotal, inCartVariantId);
  }

  disconnectedCallback() {
    document.removeEventListener('cart:change', this._onCartEvent);
    document.removeEventListener('cart:refresh', this._onCartEvent);
    if (this.helpBtn) {
      this.helpBtn.removeEventListener('click', this._onHelpClick);
    }
    if (this.checkbox) {
      this.checkbox.removeEventListener('change', this._onChange);
    }
  }

  /**
   * 根据"基础总价（不含本邮包险变体）"找到目标变体
   * 向上取：找到第一个 price >= 目标价格 的变体；若超过最大档则取最大档
   */
  _findTargetVariant(baseTotalCents) {
    if (!this.variants || this.variants.length === 0) return null;
    const targetCents = baseTotalCents * 0.025;
    for (let i = 0; i < this.variants.length; i++) {
      if (this.variants[i].price >= targetCents) return this.variants[i];
    }
    return this.variants[this.variants.length - 1];
  }

  _formatPrice(cents) {
    const value = (cents / 100).toFixed(2);
    // 简单格式化为 "$X.XX USD"
    return `$${value} ${this.currencyCode}`;
  }

  _updatePriceLabel(variant) {
    if (!variant) return;
    const formatted = this._formatPrice(variant.price);
    if (this.priceEl) {
      this.priceEl.textContent = formatted;
    }
    // 同步价格到模态框
    const modalPrice = document.querySelector('worry-free-modal [data-wf-modal-price]');
    if (modalPrice) {
      modalPrice.textContent = formatted;
    }
  }

  /**
   * 同步逻辑：
   * 1. 计算目标变体并更新展示价格
   * 2. 若购物车已有"另一档"邮包险，自动替换为目标变体
   * 3. 同步勾选框状态
   */
  _sync(baseTotalCents, inCartVariantId) {
    const target = this._findTargetVariant(baseTotalCents);
    if (!target) return;
    this._updatePriceLabel(target);
    this.targetVariantId = target.id;

    if (this._isUpdating) return;

    // 购物车已有旧档 -> 自动替换为新档
    if (inCartVariantId && inCartVariantId !== target.id) {
      this._updateCart({
        [inCartVariantId]: 0,
        [target.id]: 1,
      });
      return;
    }

    // 同步勾选状态
    if (this.checkbox) {
      this.checkbox.checked = inCartVariantId === target.id;
    }
  }

  /**
   * 用户主动切换 checkbox
   */
  _onChange(event) {
    if (this._isUpdating || !this.targetVariantId) return;
    const updates = {};
    // 移除任何已存在的邮包险变体
    this.variants.forEach((v) => {
      updates[v.id] = 0;
    });
    if (event.target.checked) {
      updates[this.targetVariantId] = 1;
    }
    this._updateCart(updates);
  }

  /**
   * cart:change / cart:refresh 触发时重新同步
   * 通过 /cart.js 获取最新的购物车数据
   */
  async _onCartEvent() {
    if (this._isUpdating) return;
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const res = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      let baseTotal = 0;
      let inCartVariantId = 0;
      const wfVariantIdSet = new Set(this.variants.map((v) => v.id));
      (cart.items || []).forEach((item) => {
        if (item.product_id === this.productId || wfVariantIdSet.has(item.variant_id)) {
          inCartVariantId = item.variant_id;
        } else {
          baseTotal += item.final_line_price;
        }
      });
      this._sync(baseTotal, inCartVariantId);
    } catch (err) {
      console.warn('[WorryFreeDelivery] 同步失败:', err);
    }
  }

  async _updateCart(updates) {
    if (this._isUpdating) return;
    this._isUpdating = true;
    if (this.checkbox) this.checkbox.disabled = true;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    // main-cart 上下文：直接拼接 /cart/update?updates[..]=.. 跳转，
    // 由服务端一次性完成变体替换并 302 回 /cart，免去 await fetch 再 reload 的双往返
    if (this.dataset.context === 'main-cart') {
      const params = new URLSearchParams();
      Object.entries(updates).forEach(([id, qty]) => {
        params.set(`updates[${id}]`, String(qty));
      });
      window.location.href = `${root}cart/update?${params.toString()}`;
      return;
    }

    try {
      await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ updates }),
      });
    } catch (err) {
      console.error('[WorryFreeDelivery] 更新购物车失败:', err);
    } finally {
      this._isUpdating = false;
      if (this.checkbox) this.checkbox.disabled = false;
      // 触发购物车刷新（让侧边栏/计数器等更新）
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }
  }

  /**
   * 点击 help 图标 -> 打开模态框并同步价格
   */
  _onHelpClick(event) {
    event.preventDefault();
    const modal = document.querySelector('worry-free-modal');
    if (!modal) return;
    const priceText = this.priceEl && this.priceEl.textContent.trim();
    const modalPrice = modal.querySelector('[data-wf-modal-price]');
    if (priceText && modalPrice) modalPrice.textContent = priceText;
    if (typeof modal.show === 'function') modal.show();
  }

  /**
   * 模态框底部按钮点击：Secure / Continue Without Protection
   * 注意：使用 DOM 实时查询，而非 this，因为该 handler 绑定在单例 modal 上，
   * 而页面中可能存在多个 worry-free-delivery 实例（cart-drawer + main-cart）。
   */
  _onModalAction(event) {
    const actionBtn = event.target.closest('[data-wf-action]');
    if (!actionBtn) return;
    const action = actionBtn.dataset.wfAction;
    const modal = event.currentTarget;

    // 实时获取页面中所有 worry-free-delivery 的 checkbox
    const checkboxes = document.querySelectorAll('worry-free-delivery [data-wf-checkbox]');
    if (checkboxes.length === 0) {
      if (modal && typeof modal.hide === 'function') modal.hide();
      return;
    }

    if (action === 'secure') {
      // 找到第一个未勾选的 checkbox，触发勾选 + change（_updateCart 会广播 cart:refresh，其它实例自动同步）
      const target = Array.from(checkboxes).find((c) => !c.checked) || checkboxes[0];
      if (!target.checked) {
        target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else if (action === 'decline') {
      const target = Array.from(checkboxes).find((c) => c.checked);
      if (target) {
        target.checked = false;
        target.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    if (modal && typeof modal.hide === 'function') modal.hide();
  }
}

if (!window.customElements.get('worry-free-delivery')) {
  customElements.define('worry-free-delivery', WorryFreeDelivery);
}

// 自定义：Quick Fit Check —— 两个 tab 切换 + 加购
class QuickFitCheck extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;
  }

  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-qfc-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-qfc-panel]'));

    // Tab 切换
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activateTab(tab.getAttribute('data-qfc-tab')));
    });

    // 跳转按钮：See other options / Back to this model
    this.querySelectorAll('[data-qfc-goto]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const targetType = btn.getAttribute('data-qfc-goto');
        const tab = this.tabs.find((t) => t.getAttribute('data-qfc-type') === targetType);
        if (tab) this.activateTab(tab.getAttribute('data-qfc-tab'));
      });
    });

    // 加购按钮：Yes, this fits me
    this.querySelectorAll('[data-qfc-atc]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.addToCart(btn);
      });
    });
  }

  activateTab(id) {
    if (!id) return;
    this.tabs.forEach((t) => t.classList.toggle('is-active', t.getAttribute('data-qfc-tab') === id));
    this.panels.forEach((p) => p.classList.toggle('is-active', p.getAttribute('data-qfc-panel') === id));
  }

  async addToCart(btn) {
    const variantId = btn.getAttribute('data-variant-id');
    if (this.isLoading || !variantId) return;

    this.isLoading = true;
    btn.classList.add('is-loading');

    try {
      const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      });
      if (!res.ok) throw new Error('Add to cart failed');

      document.dispatchEvent(new CustomEvent('cart:show'));
      if (!document.body.classList.contains('smart-cart--enabled')) {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    } catch (err) {
      console.error('QuickFitCheck ATC error:', err);
    } finally {
      this.isLoading = false;
      btn.classList.remove('is-loading');
    }
  }
}

if (!window.customElements.get('quick-fit-check')) {
  customElements.define('quick-fit-check', QuickFitCheck);
}

// 自定义：Find Your Fit Quiz
// 三步问答 -> 基于元字段(exactly_match_tags)与预算区间精确匹配单个产品
class FindYourFitQuiz extends HTMLElement {
  constructor() {
    super();
    this.products = [];
    this.config = {};
    this.answers = {};
    this.currentStep = 1;
    this._copyTimer = null;
  }

  connectedCallback() {
    // 1. 解析数据与配置
    try {
      const dataScript = this.querySelector('.ffq-data');
      const configScript = this.querySelector('.ffq-config');
      if (dataScript) this.products = JSON.parse(dataScript.textContent) || [];
      if (configScript) this.config = JSON.parse(configScript.textContent) || {};
    } catch (e) {
      console.error('FindYourFitQuiz: failed to parse data', e);
      this.products = [];
      this.config = {};
    }

    // 2. 数据预处理
    this.products = this.products.map((p) => {
      // answer_of_question: 多个问题用 ; 分隔，同一问题的多个答案用 , 分隔
      p.answers_by_question = String(p.answer_of_question_raw || '')
        .split(';')
        .map((seg) =>
          seg
            .split(',')
            .map((s) => s.trim())
            .filter(Boolean)
        );
      p.features = String(p.features_raw || '')
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean);
      const shortName = String(p.short_name || '').trim();
      p.name = shortName ? shortName : p.title;
      p.description = String(p.description || '').trim();
      p.price_num = Number(p.price_num) || 0;
      return p;
    });

    // 3. 收集步骤 & 结果节点
    this.steps = Array.from(this.querySelectorAll('.ffq-step'));
    this.totalSteps = this.steps.length;
    this.resultEl = this.querySelector('.ffq-result');

    // 4. 绑定事件并回到第一步
    this.bindEvents();
    this.goToStep(1);
  }

  bindEvents() {
    this.querySelectorAll('.ffq-option').forEach((btn) => {
      btn.addEventListener('click', () => this.handleAnswer(btn));
    });
    this.querySelectorAll('.ffq-back').forEach((btn) => {
      btn.addEventListener('click', () => this.handleBack());
    });
    this.querySelectorAll('.ffq-restart-btn').forEach((btn) => {
      btn.addEventListener('click', () => this.handleRestart());
    });
    const copyBtn = this.querySelector('.ffq-copy-btn');
    if (copyBtn) {
      copyBtn.addEventListener('click', () => this.handleCopy(copyBtn));
    }
  }

  goToStep(n) {
    this.currentStep = n;
    this.steps.forEach((step) => {
      const idx = parseInt(step.dataset.step, 10);
      step.hidden = idx !== n;
    });
    if (this.resultEl) this.resultEl.hidden = true;
  }

  handleAnswer(btn) {
    const step = btn.closest('.ffq-step');
    if (!step) return;
    const stepIndex = parseInt(step.dataset.step, 10);
    const stepType = step.dataset.type;

    // 同一步内单选
    step.querySelectorAll('.ffq-option').forEach((b) => b.classList.remove('active'));
    btn.classList.add('active');

    if (stepType === 'budget') {
      this.answers[stepIndex] = { type: 'budget', tier: btn.dataset.tier };
    } else {
      this.answers[stepIndex] = { type: 'question', value: btn.dataset.value };
    }

    // 前进到下一步；若为最后一步则计算并展示结果
    if (stepIndex < this.totalSteps) {
      this.goToStep(stepIndex + 1);
    } else {
      this.showResult();
    }
  }

  handleBack() {
    const prev = this.currentStep - 1;
    if (prev < 1) return;
    // 清空上一个问题的答案，让用户重新选择
    delete this.answers[prev];
    const prevStep = this.steps.find((s) => parseInt(s.dataset.step, 10) === prev);
    if (prevStep) {
      prevStep.querySelectorAll('.ffq-option').forEach((b) => b.classList.remove('active'));
    }
    this.goToStep(prev);
  }

  handleRestart() {
    this.answers = {};
    this.querySelectorAll('.ffq-option.active').forEach((b) => b.classList.remove('active'));
    this.goToStep(1);
  }

  showResult() {
    const product = this.computeMatch();
    this.renderResult(product);
    this.steps.forEach((s) => {
      s.hidden = true;
    });
    if (this.resultEl) this.resultEl.hidden = false;
  }

  /**
   * 核心匹配算法
   * 第一步：按第三个问题（预算）筛选出集合 A（用 selected_or_first_available_variant 的价格）。
   *   - 低价档：price <= low_max
   *   - 区间档：range_low <= price <= range_high
   *   - 高价档：price >= high_min
   * 第二步：在集合 A 中按前面问题的答案筛选出集合 B。
   *   - (一) 优先取“全部匹配”前面问题答案的产品；
   *   - (二) 否则取“匹配其中一个答案”的产品；
   *   - (三) 仍为空则集合 B = 集合 A 的拷贝。
   * 第三步：尾巴处理。
   *   - 低价档：返回集合 B 中价格最低的产品；
   *   - 区间/高价档：随机返回集合 B 中的一个产品。
   */
  computeMatch() {
    // 按步骤顺序收集前面问题的答案 + 预算档位
    const questionAnswers = [];
    let budgetTier = null;
    Object.keys(this.answers)
      .map(Number)
      .sort((a, b) => a - b)
      .forEach((k) => {
        const a = this.answers[k];
        if (a.type === 'question') {
          questionAnswers.push(a.value);
        } else if (a.type === 'budget') {
          budgetTier = a.tier;
        }
      });

    const b = this.config.budget || {};

    // 第一步：按预算筛选得到集合 A
    const setA = this.products.filter((p) => {
      if (budgetTier === 'low') return p.price_num <= b.low_max;
      if (budgetTier === 'range') return p.price_num >= b.range_low && p.price_num <= b.range_high;
      if (budgetTier === 'high') return p.price_num >= b.high_min;
      return true; // 无预算档位时不按价格筛选（兜底）
    });

    if (!setA.length) return null;

    // 答案规范化：去首尾空格 + 转小写，避免前台答案与元字段大小写/空格不一致导致漏配
    // （例如前台答案 "Save money" 与元字段 "Save Money" 应视为同一个答案）
    const norm = (s) => String(s == null ? '' : s).trim().toLowerCase();
    const normSelected = questionAnswers.map(norm);
    const matchesQuestion = (p, i, normAns) =>
      (p.answers_by_question[i] || []).some((a) => norm(a) === normAns);

    // 第二步：按前面问题的答案，在集合 A 中筛选出集合 B
    let setB;
    if (normSelected.length) {
      // (一) 全部匹配：每个问题的已选答案都在产品对应问题的答案列表中
      setB = setA.filter((p) => normSelected.every((ans, i) => matchesQuestion(p, i, ans)));
      // (二) 匹配其中一个答案
      if (!setB.length) {
        setB = setA.filter((p) => normSelected.some((ans, i) => matchesQuestion(p, i, ans)));
      }
      // (三) 一个都匹配不上：集合 B = 集合 A 的拷贝
      if (!setB.length) {
        setB = setA.slice();
      }
    } else {
      setB = setA.slice();
    }

    if (!setB.length) return null;

    // 第三步：尾巴处理
    if (budgetTier === 'low') {
      // 返回价格最低的产品
      return setB.reduce((best, p) => (p.price_num < best.price_num ? p : best), setB[0]);
    }
    // 区间/高价档：随机返回集合 B 中的一个
    return setB[Math.floor(Math.random() * setB.length)];
  }

  renderResult(product) {
    if (!this.resultEl) return;
    const match = this.resultEl.querySelector('.ffq-match');
    const empty = this.resultEl.querySelector('.ffq-empty');

    if (!product) {
      if (match) match.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }

    if (match) match.hidden = false;
    if (empty) empty.hidden = true;

    // 产品链接（卡片 + Shop This Match）
    this.resultEl.querySelectorAll('[data-product-link]').forEach((a) => {
      a.setAttribute('href', product.url || '#');
    });

    // 图片
    const media = this.resultEl.querySelector('.ffq-match-media');
    const img = this.resultEl.querySelector('[data-product-image]');
    if (product.image) {
      if (img) {
        img.src = product.image;
        img.alt = product.name || '';
      }
      if (media) media.hidden = false;
    } else if (media) {
      media.hidden = true;
    }

    // 名称
    const nameEl = this.resultEl.querySelector('[data-product-name]');
    if (nameEl) nameEl.textContent = product.name || '';

    // 描述
    const descEl = this.resultEl.querySelector('[data-product-desc]');
    if (descEl) {
      descEl.textContent = product.description || '';
      descEl.hidden = !product.description;
    }

    // 特征标签
    const featEl = this.resultEl.querySelector('[data-product-features]');
    if (featEl) {
      featEl.innerHTML = '';
      const tagsLimit = Number(this.config.tags_limit) || 0;
      let features = product.features || [];
      if (tagsLimit > 0) features = features.slice(0, tagsLimit);
      features.forEach((f) => {
        const span = document.createElement('span');
        span.className = 'ffq-feature';
        span.textContent = f;
        featEl.appendChild(span);
      });
    }
  }

  handleCopy(btn) {
    const code = btn.dataset.copyCode || '';
    const copyText = btn.dataset.copyText || 'Copy Code';
    const copiedText = btn.dataset.copiedText || 'Copied';

    const done = () => {
      btn.textContent = copiedText;
      btn.classList.add('is-copied');
      clearTimeout(this._copyTimer);
      this._copyTimer = setTimeout(() => {
        btn.textContent = copyText;
        btn.classList.remove('is-copied');
      }, 3000);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(code)
        .then(done)
        .catch(() => this._fallbackCopy(code, done));
    } else {
      this._fallbackCopy(code, done);
    }
  }

  _fallbackCopy(text, done) {
    try {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    } catch (e) {
      /* noop */
    }
    done();
  }
}

if (!window.customElements.get('find-your-fit-quiz')) {
  customElements.define('find-your-fit-quiz', FindYourFitQuiz);
}